<template>
    <div>
        <div v-if="chkViewMain === 'Onsite' || chkViewKbank == true">
            <v-row class="mar-t-10">
                <v-col v-if="chkViewKbank == false" cols="12" class="mar-t-20">
                    <v-chip
                        class="ma-2"
                        v-for="(row_d, index_d) in status_onsite_at"
                        :disabled="
                            row_d.status_date == 'today' &&
                                status_onsite_at.length > 1
                        "
                        :key="index_d"
                        :color="
                            row_d.status_date == 'yesterday' ? 'red' : 'amber'
                        "
                        text-color="white"
                        @click="get_data(row_d.onsite_at, index_d)"
                    >
                        <v-avatar
                            left
                            :class="
                                row_d.status_date == 'yesterday'
                                    ? 'red lighten-4'
                                    : 'amber lighten-4'
                            "
                            style="color: #01579b !important;font-weight: bold !important;"
                        >
                            {{
                                onsite_at == row_d.onsite_at
                                    ? data_main.length
                                    : row_d.num_cases
                            }}
                        </v-avatar>
                        {{ row_d.onsite_date }}
                        <v-avatar right v-if="onsite_at == row_d.onsite_at">
                            <v-icon>mdi-checkbox-marked-circle</v-icon>
                        </v-avatar>
                    </v-chip>
                </v-col>

                <v-col
                    cols="11"
                    :class="chkViewKbank == true ? 'mar-t-10' : 'mar-t-20'"
                >
                    <v-text-field
                        outlined
                        dense
                        @input="func_kbank_search_case()"
                        v-model="kbank_search_case"
                        :label="'Search Case Onsite ' + onsite_at"
                        prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                </v-col>
                <v-col cols="1" class="mar-t-10">
                    <v-btn
                        x-small
                        fab
                        class="mr-1"
                        v-if="kbank_search_case && kbank_search_case.length > 0"
                        @click="reset_kbank_search_case()"
                    >
                        <v-icon>mdi-rotate-left</v-icon></v-btn
                    >
                </v-col>
            </v-row>

            <div
                class="no-pd no-pd-1"
                style="margin-top: -19px !important;border-top: 1px dotted #7292b0;
                "
            >
                <v-carousel
                    :continuous="true"
                    :cycle="false"
                    :show-arrows="false"
                    light
                    height="100%"
                    hide-delimiter-background
                    show-arrows-on-hover
                >
                    <v-carousel-item
                        v-for="(row, i) in data_main"
                        :key="i"
                        height="100%"
                    >
                        <v-sheet
                            height="100%"
                            tile
                            :color="
                                row.schedule_range_id === '99'
                                    ? 'yellow lighten-4'
                                    : ''
                            "
                        >
                            <v-row class="ml-1 mr-1">
                                <v-col cols="6" md="4">
                                    <v-btn
                                        :color="status_color[row.status_color]"
                                        @click="
                                            change_case(
                                                row.parts,
                                                row.maincase_id,
                                                row.subcase,
                                                row.project_name,
                                                row.problem_type_name,
                                                row.case_id,
                                                row.product_group,
                                                row.warranty_type,
                                                row.case_title,
                                                row.customer_email,
                                                row.team_name,
                                                row.e_cso,
                                                row.wonumber,
                                                row
                                            )
                                        "
                                        class="mr-1"
                                        block
                                    >
                                        {{ row.case_id + "-" + row.subcase }}

                                        <v-icon
                                            class="ml-1"
                                            color="red"
                                            v-if="
                                                row.show_ismart == 'Y' &&
                                                    data_eeg1.skip_ismart ==
                                                        'N' &&
                                                    data_eeg1.project_name ==
                                                        'CDAX'
                                            "
                                        >
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="2">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                style="margin-left: -15px; margin-top: 3px;"
                                                x-small
                                                v-on="on"
                                                fab
                                                @click="doCopyLog(row.case_id)"
                                            >
                                                <v-icon
                                                    >mdi-content-copy</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Copy {{ row.case_id }}</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="12" md="4" class="text-right mt-1">
                                    <v-chip>
                                        <!-- <v-icon small color="info" class="mr-1">
                                            mdi-timer
                                        </v-icon> -->
                                        {{ row.created_date }}
                                    </v-chip>
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="mar-t-10"
                                    v-if="row.special == 'Y'"
                                >
                                    <strong style="color: red">
                                        -- รบกวนช่างเก็บข้อมูลส่ง PS ด้วย --
                                    </strong>
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="mar-t-10"
                                    v-if="row.subcase_wonumber"
                                >
                                    <v-icon color="primary" class="mr-1"
                                        >mdi-package-variant</v-icon
                                    >
                                    <strong style="color: #455a64">{{
                                        row.subcase_wonumber
                                    }}</strong>
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="mar-t-10"
                                    v-else-if="row.wonumber"
                                >
                                    <span class="primary--text font-b">
                                        {{ row.wonumber }}
                                    </span>

                                    <v-tooltip top class="ml-1">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                x-small
                                                v-on="on"
                                                fab
                                                @click="doCopyLog(row.wonumber)"
                                            >
                                                <v-icon
                                                    >mdi-content-copy</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Copy {{ row.wonumber }}</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="12" class="mar-t-10">
                                    <v-icon color="primary" class="mr-1"
                                        >mdi-home-circle</v-icon
                                    >
                                    <strong style="color: #455a64">{{
                                        row.site_name
                                    }}</strong>
                                </v-col>
                                <v-col cols="12" class="mar-t-10">
                                    <v-icon color="orange darken-3" class="mr-1"
                                        >mdi-home-map-marker</v-icon
                                    >
                                    <strong style="color: #ef6c00">{{
                                        row.site_address
                                    }}</strong>
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="mar-t-10"
                                    v-if="row.hp_case_id"
                                >
                                    <b class="indigo--text">HP Case : </b>
                                    <span class="indigo--text">{{
                                        row.hp_case_id
                                    }}</span>
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="mar-t-10"
                                    v-if="row.case_refer"
                                >
                                    <b>Case Refer :</b> {{ row.case_refer }}
                                </v-col>
                                <v-col cols="12" class="mar-t-10">
                                    <v-icon color="primary"
                                        >mdi-car-estate</v-icon
                                    >
                                    {{ row.case_title }}
                                    <br v-if="row.subcase_title" />
                                    <v-chip
                                        v-if="row.subcase_title"
                                        small
                                        color="purple lighten-4"
                                        >{{ row.subcase_title }}</v-chip
                                    >
                                </v-col>
                                <v-col class="mar-t-10" cols="6"
                                    ><v-icon color="primary">
                                        mdi-account-circle</v-icon
                                    >
                                    {{ row.customer_name }}
                                </v-col>
                                <v-col class="mar-t-10" cols="6">
                                    <span v-if="row.schedule_range">
                                        <v-icon color="primary">
                                            mdi-clock-fast</v-icon
                                        >
                                        {{ row.schedule_range }}
                                    </span>
                                </v-col>
                                <v-col
                                    class="mar-t-10"
                                    cols="6"
                                    v-for="phone in row.customer_tel"
                                    :key="phone"
                                >
                                    <v-icon style="color: #dbb20d">
                                        mdi-whatsapp
                                    </v-icon>
                                    <a
                                        style="color: #dbb20d;font-weight: bold;"
                                        :href="`tel:${phone}`"
                                        @click="saveCallLog(row.subcase_id)"
                                        class="ml-1"
                                        >{{ phone }}</a
                                    >
                                </v-col>

                                <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-if="row.customer_email"
                                >
                                    <v-icon color="primary">mdi-gmail</v-icon>
                                    {{ row.customer_email }}
                                </v-col>
                                <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-if="
                                        row.product_no ||
                                            row.product_description
                                    "
                                >
                                    <v-icon color="primary"
                                        >mdi-cellphone-link</v-icon
                                    >
                                    {{ row.product_no }}
                                    <span v-if="row.product_description">
                                        - {{ row.product_description }}</span
                                    >
                                </v-col>
                                <v-col class="mar-t-10" cols="12">
                                    <v-icon color="primary">mdi-tag</v-icon>
                                    {{ row.product_serial }}
                                </v-col>

                                <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-if="row.remark"
                                >
                                    <v-icon color="primary"
                                        >mdi-chat-alert</v-icon
                                    >{{ row.remark }}
                                </v-col>

                                <!-- <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-if="row.DmrFlag"
                                >
                                    <span
                                        :class="
                                            row.DmrFlag == 'Yes'
                                                ? 'red--text font-b'
                                                : ''
                                        "
                                    >
                                        Dmr Flag : {{ row.DmrFlag }}</span
                                    >
                                </v-col> -->

                                <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-for="(r, index) in row.parts"
                                    :key="index"
                                >
                                    <div v-if="r.status != 'Back Order'">
                                        <v-icon
                                            :style="
                                                r.status == 'Reserve'
                                                    ? 'color:#D500F9; font-weight: bold;'
                                                    : 'color:#0097A7; font-weight: bold;'
                                            "
                                            >mdi-pound</v-icon
                                        >
                                        <strong
                                            :style="
                                                r.status == 'Reserve'
                                                    ? 'color:#D500F9; font-weight: bold;'
                                                    : 'color:#0097A7; font-weight: bold;'
                                            "
                                        >
                                            <span
                                                v-if="
                                                    r.ponumber &&
                                                        r.ponumber !== 'null'
                                                "
                                                >{{ r.ponumber + " / " }}</span
                                            >
                                            {{
                                                r.part_name +
                                                    " - " +
                                                    r.part_description
                                            }}
                                            <span
                                                class="ml-1"
                                                v-if="r.status == 'Reserve'"
                                            >
                                                *ใช้ Spare part ที่ศูนย์
                                            </span>
                                            <span v-else class="ml-1">
                                                {{ "*" + r.status }}
                                            </span>
                                        </strong>
                                    </div>
                                    <div v-else>
                                        <v-icon color="primary"
                                            >mdi-pound</v-icon
                                        >
                                        ให้เข้าตรวจสอบก่อนว่าใช้ Part หรือไม่
                                        {{
                                            r.part_name +
                                                " - " +
                                                r.part_description
                                        }}
                                    </div>
                                </v-col>

                                <!-- <v-col cols="12" class="text-center">
                                    <span class="red--text font-b">
                                        {{
                                            row.e_cso == "Y"
                                                ? "มีการทดสอบ e-cso eform 3 วัน"
                                                : ""
                                        }}
                                    </span>
                                </v-col> -->
                            </v-row>

                            <v-row v-if="row.lognote.length > 0">
                                <v-col cols="12">
                                    <v-textarea
                                        readonly
                                        outlined
                                        v-model="row.lognote"
                                        background-color="#e6f3ff"
                                        label="Log Note..."
                                        rows="6"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-carousel-item>
                </v-carousel>
            </div>

            <!-- btn - add return pickup -->
            <div v-if="chkViewKbank == false">
                <v-row
                    class="text-center no-pd"
                    v-if="
                        status_onsite_at.length == 1 &&
                            data_main.length > 0 &&
                            (team_name == 'ONSITE' || team_name == 'NONHP')
                    "
                >
                    <v-col cols="11">
                        <v-btn
                            small
                            color="yellow"
                            class="ml-3"
                            @click="dialogAdd = true"
                            block
                        >
                            <v-icon small class="mr-1">mdi-plus-circle</v-icon>
                            Add Return Pickup
                        </v-btn>
                    </v-col>
                </v-row>
            </div>

            <!-- btn - add return pickup -->
            <v-row justify="center">
                <v-form method="post" id="nativeForm" v-model="valid">
                    <v-dialog v-model="dialogAdd" persistent max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline"
                                    >Add Return Pickup Part</span
                                >
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row class="mar-t-30">
                                        <v-col cols="12">
                                            <v-select
                                                dense
                                                outlined
                                                v-model="form_return.return_to"
                                                :items="[
                                                    'SVC/WFH',
                                                    'Bus terminal',
                                                    'Kerry',
                                                    'Airport',
                                                ]"
                                                label="Return to ..."
                                                required
                                                @change="change_return_to()"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mar-t-10">
                                        <v-col cols="12">
                                            <v-textarea
                                                outlined
                                                v-model="form_return.remark"
                                                label="Remark..."
                                                :rules="RemarkR"
                                                background-color="#FFFF"
                                                rows="4"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        class="no-pd mar-t-20"
                                        justify="center"
                                        v-if="form_return.return_to != ''"
                                    >
                                        <v-col
                                            cols="12"
                                            style="background-color: #e1f5ff"
                                        >
                                            <v-progress-linear
                                                v-if="show_address === ''"
                                                indeterminate
                                                color="cyan"
                                            ></v-progress-linear>
                                            <div id="app">
                                                <gmap-map
                                                    v-show="showMap"
                                                    ref="map"
                                                    id="map"
                                                    :center="mapStart"
                                                    :zoom="11"
                                                    style="width: 100%;height: 200px;"
                                                >
                                                    <DirectionsRenderer
                                                        @dragend="getDirection"
                                                    />
                                                </gmap-map>
                                            </div>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            style="background-color: #e1f5ff"
                                        >
                                            <v-progress-linear
                                                v-if="show_address === ''"
                                                indeterminate
                                                color="cyan"
                                            ></v-progress-linear>
                                            <span style="color: #2c5aa3">{{
                                                show_address
                                            }}</span
                                            ><br /><br />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <div style="text-align: center">
                                                <vue-upload-multiple-image
                                                    @upload-success="
                                                        uploadImageSuccess4
                                                    "
                                                    @before-remove="
                                                        beforeRemove4
                                                    "
                                                    @edit-image="editImage4"
                                                    @data-change="dataChange4"
                                                    dragText="UPLOAD"
                                                    browseText="ATTACH"
                                                    primaryText="attach image"
                                                    markIsPrimaryText="จัดลำดับรูปภาพ"
                                                    idUpload="myIdUpload3"
                                                    editUpload="myIdEdit3"
                                                    :maxImage="50"
                                                ></vue-upload-multiple-image>
                                                <span
                                                    class="text-color-red font-fix-13"
                                                    v-if="chk_attach4 === true"
                                                    >** ATTACH Upload is
                                                    required</span
                                                >
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="mr-5">
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="close_dialogAdd()"
                                    >Close</v-btn
                                >
                                <v-btn
                                    color="success darken-1"
                                    :disabled="!valid"
                                    @click="save_return(1)"
                                    >Save</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-form>
            </v-row>

            <v-row justify="center">
                <v-dialog
                    v-model="dialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dense dark color="primary">
                            <v-btn
                                icon
                                dark
                                @click="close_dialog()"
                                v-if="
                                    chk_save_step != 2 &&
                                        show_rate == false &&
                                        show_sign == false &&
                                        show_ismart == false
                                "
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                dark
                                @click="back_2()"
                                v-if="
                                    chk_save_step == 2 &&
                                        show_rate == false &&
                                        show_sign == false &&
                                        show_ismart == false
                                "
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>
                                <v-row>
                                    <v-col cols="11">
                                        {{
                                            show_title_case_id +
                                                "-" +
                                                this.form_1.subcase
                                        }}
                                    </v-col>
                                </v-row>
                            </v-toolbar-title>
                        </v-toolbar>

                        <div
                            v-if="
                                show_rate == false &&
                                    show_sign == false &&
                                    show_ismart == false
                            "
                        >
                            <v-form
                                method="post"
                                id="nativeForm"
                                v-model="valid"
                            >
                                <v-row
                                    justify="center"
                                    class="mt-2"
                                    v-if="chk_form_action != 1"
                                >
                                    <!-- {{ data_eeg1.show_ismart }}//{{ eeg_subcase_status_id }} -->

                                    <v-col
                                        cols="5"
                                        class="text-right"
                                        v-if="
                                            data_eeg1.show_ismart == 'Y' &&
                                                data_eeg1.skip_ismart == 'N' &&
                                                (eeg_subcase_status_id ==
                                                    null ||
                                                    eeg_subcase_status_id ==
                                                        2 ||
                                                    eeg_subcase_status_id == 7)
                                        "
                                    >
                                        Time Start
                                        <vue-timepicker
                                            v-model="form_eeg_1.start"
                                            class="mt-1"
                                        ></vue-timepicker>
                                    </v-col>
                                    <v-col
                                        cols="5"
                                        v-if="
                                            data_eeg1.show_ismart == 'Y' &&
                                                data_eeg1.skip_ismart == 'N' &&
                                                (eeg_subcase_status_id ==
                                                    null ||
                                                    eeg_subcase_status_id ==
                                                        2 ||
                                                    eeg_subcase_status_id == 7)
                                        "
                                    >
                                        Time Stop
                                        <vue-timepicker
                                            v-model="form_eeg_1.stop"
                                            class="mt-1"
                                        ></vue-timepicker>
                                    </v-col>

                                    <v-col
                                        cols="5"
                                        v-if="
                                            eeg_subcase_status_id == 3 &&
                                                data_eeg1.show_ismart == 'Y' &&
                                                data_eeg1.skip_ismart == 'N'
                                        "
                                    >
                                        Booking Time Start
                                        <vue-timepicker
                                            v-model="form_eeg_2.start"
                                            class="mt-1"
                                        ></vue-timepicker>
                                    </v-col>
                                    <v-col
                                        cols="5"
                                        v-if="
                                            eeg_subcase_status_id == 3 &&
                                                data_eeg1.show_ismart == 'Y' &&
                                                data_eeg1.skip_ismart == 'N'
                                        "
                                    >
                                        Booking Time Stop
                                        <vue-timepicker
                                            v-model="form_eeg_2.stop"
                                            class="mt-1"
                                        ></vue-timepicker>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        v-if="
                                            eeg_subcase_status_id == 3 &&
                                                data_eeg1.show_ismart == 'Y' &&
                                                data_eeg1.skip_ismart == 'N'
                                        "
                                    >
                                        ActualArrival Time
                                        <vue-timepicker
                                            v-model="
                                                form_eeg_2.ActualArrivalTime
                                            "
                                            class="mt-1"
                                        ></vue-timepicker>
                                    </v-col>

                                    <v-col cols="10" md="7">
                                        <v-btn
                                            :disabled="
                                                form_eeg_1.start.HH == '' ||
                                                    form_eeg_1.start.mm == '' ||
                                                    form_eeg_1.stop.HH == '' ||
                                                    form_eeg_1.stop.mm == ''
                                            "
                                            v-if="
                                                data_eeg1.show_ismart == 'Y' &&
                                                    data_eeg1.skip_ismart ==
                                                        'N' &&
                                                    (eeg_subcase_status_id ==
                                                        2 ||
                                                        eeg_subcase_status_id ==
                                                            7)
                                            "
                                            block
                                            color="red"
                                            class="white--text"
                                            @click="
                                                save_eeg_step(
                                                    'Engineer Traveling'
                                                )
                                            "
                                        >
                                            Engineer Traveling
                                        </v-btn>
                                        <v-btn
                                            v-if="
                                                eeg_subcase_status_id == 3 &&
                                                    data_eeg1.show_ismart ==
                                                        'Y' &&
                                                    data_eeg1.skip_ismart == 'N'
                                            "
                                            block
                                            color="amber"
                                            :disabled="
                                                form_eeg_2.start.HH == '' ||
                                                    form_eeg_2.start.mm == '' ||
                                                    form_eeg_2.stop.HH == '' ||
                                                    form_eeg_2.stop.mm == '' ||
                                                    form_eeg_2.ActualArrivalTime
                                                        .HH == '' ||
                                                    form_eeg_2.ActualArrivalTime
                                                        .mm == ''
                                            "
                                            @click="
                                                save_eeg_step('Engineer Onsite')
                                            "
                                        >
                                            Engineer Onsite
                                        </v-btn>

                                        <v-btn
                                            v-if="
                                                (eeg_subcase_status_id == 4 &&
                                                    data_eeg1.show_ismart ==
                                                        'Y' &&
                                                    data_eeg1.skip_ismart ==
                                                        'N') ||
                                                    (form_1.project_name ==
                                                        'CDAX' &&
                                                        data_eeg1.show_ismart ==
                                                            'N') ||
                                                    (form_1.project_name ==
                                                        'CDAX' &&
                                                        data_eeg1.show_ismart ==
                                                            'Y' &&
                                                        data_eeg1.skip_ismart ==
                                                            'Y') ||
                                                    data_eeg1.skip_ismart ==
                                                        NULL ||
                                                    form_1.project_name !=
                                                        'CDAX'
                                            "
                                            block
                                            @click="change_btn_action(1)"
                                            color="primary"
                                        >
                                            Close Case
                                        </v-btn>
                                    </v-col>
                                    <!-- <v-col cols="10" md="7">
                                        <v-btn
                                            :color="
                                                chk_form_action === 7
                                                    ? 'success'
                                                    : 'primary'
                                            "
                                            block
                                            @click="change_btn_action(7)"
                                            >โอนงานให้คนอื่น</v-btn
                                        >
                                    </v-col> -->
                                    <v-col cols="10" md="7">
                                        <v-btn
                                            :color="
                                                chk_form_action === 2
                                                    ? 'success'
                                                    : 'primary'
                                            "
                                            block
                                            @click="change_btn_action(2)"
                                            >เลื่อนวันวิ่งงาน</v-btn
                                        >
                                    </v-col>
                                    <v-col cols="10" md="7">
                                        <v-btn
                                            :color="
                                                chk_form_action === 3
                                                    ? 'success'
                                                    : 'primary'
                                            "
                                            block
                                            @click="change_btn_action(3)"
                                            >ติดต่อลูกค้าไม่ได้</v-btn
                                        >
                                    </v-col>
                                    <v-col cols="10" md="7">
                                        <v-btn
                                            :color="
                                                chk_form_action === 4
                                                    ? 'success'
                                                    : 'primary'
                                            "
                                            block
                                            @click="change_btn_action(4)"
                                            >ลูกค้าขอยกเลิก</v-btn
                                        >
                                    </v-col>
                                    <!-- <v-col cols="10" md="7">
                                        <v-btn
                                            :color="
                                                chk_form_action === 9
                                                    ? 'success'
                                                    : 'primary'
                                            "
                                            block
                                            @click="change_btn_action(9)"
                                            >เข้าออนไซต์ไม่ทัน</v-btn
                                        >
                                    </v-col> -->
                                    <v-col
                                        cols="10"
                                        md="7"
                                        v-if="team_name == 'NONHP'"
                                    >
                                        <v-btn
                                            :color="
                                                chk_form_action === 5
                                                    ? 'success'
                                                    : 'primary'
                                            "
                                            block
                                            @click="change_btn_action(5)"
                                            >ดึงเคสกลับโซน</v-btn
                                        >
                                    </v-col>
                                    <v-col
                                        cols="10"
                                        md="7"
                                        v-if="
                                            team_name == 'NONHP' ||
                                                team_name == 'OKI' ||
                                                team_name == 'ASUS'
                                        "
                                    >
                                        <v-btn
                                            :color="
                                                chk_form_action === 6
                                                    ? 'success'
                                                    : 'primary'
                                            "
                                            block
                                            @click="change_btn_action(6)"
                                            >Clear By Phone</v-btn
                                        >
                                    </v-col>
                                    <!-- <v-col
                                        cols="10"
                                        md="7"
                                        v-if="team_name == 'ONSITE'"
                                    >
                                        <v-btn
                                            :color="
                                                chk_form_action === 8
                                                    ? 'success'
                                                    : 'red accent-2'
                                            "
                                            block
                                            @click="change_btn_action(8)"
                                            >ลูกค้าไม่สะดวกนัด /
                                            ไม่สามารถเข้าไซท์ได้
                                        </v-btn>
                                    </v-col> -->
                                    <v-col
                                        cols="10"
                                        md="7"
                                        v-if="
                                            chk_form_action === 2 ||
                                                chk_form_action === 9
                                        "
                                    >
                                        <v-dialog
                                            ref="dialog"
                                            v-model="modal"
                                            :return-value.sync="form_2.date"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    outlined
                                                    v-model="form_2.date"
                                                    label="Date"
                                                    prepend-icon=""
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                :min="date_min"
                                                v-model="form_2.date"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal = false"
                                                    >Cancel</v-btn
                                                >
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="
                                                        $refs.dialog.save(
                                                            form_2.date
                                                        )
                                                    "
                                                    >OK</v-btn
                                                >
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col
                                        cols="10"
                                        md="7"
                                        v-if="chk_form_action === 7"
                                    >
                                        <v-select
                                            dense
                                            outlined
                                            :items="data_emp"
                                            label="Zone"
                                            item-text="branch_name"
                                            item-value="engineer"
                                            v-model="zone"
                                            required
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        class="mar-t-20"
                                        cols="10"
                                        md="7"
                                        v-if="chk_form_action === 7"
                                    >
                                        <v-select
                                            dense
                                            outlined
                                            :items="zone"
                                            label="Engineer"
                                            item-text="emp_name_en"
                                            item-value="emp_id"
                                            v-model="form_2.engineer_id"
                                            required
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="10"
                                        md="7"
                                        v-if="chk_form_action >= 2"
                                    >
                                        <v-textarea
                                            outlined
                                            v-model="form_2.remark"
                                            label="Remark..."
                                            :rules="RemarkR"
                                            background-color="#FFFF"
                                            rows="4"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col
                                        cols="10"
                                        md="7"
                                        v-if="chk_form_action != 0"
                                        class="mar-t-30"
                                    >
                                        <v-btn
                                            color="success"
                                            block
                                            :disabled="!valid"
                                            @click="func_eeg_api()"
                                        >
                                            <v-icon small class="mr-1">
                                                mdi-content-save
                                            </v-icon>
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <div v-if="chk_form_action === 1">
                                    <v-row justify="center">
                                        <v-col cols="10">
                                            <strong>{{ case_title }}</strong>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-chip
                                                :color="
                                                    chk_save_img == true
                                                        ? 'green accent-2'
                                                        : ''
                                                "
                                                class="mar-t-20"
                                            >
                                                <b>Step 1 : Upload Images</b>
                                            </v-chip>
                                            <img
                                                class="ml-1"
                                                src="../../../assets/all/Loading.gif"
                                                style="width: 8.5%"
                                                v-if="
                                                    chk_save_step == 2 &&
                                                        chk_save_img == false &&
                                                        countNumTimer < 35
                                                "
                                            />
                                            <v-btn
                                                small
                                                fab
                                                class="ml-1 mar-t-20"
                                                v-if="
                                                    chk_save_step == 2 &&
                                                        chk_save_img == false &&
                                                        countNumTimer < 35
                                                "
                                            >
                                                <b>{{ countNumTimer }}</b>
                                            </v-btn>

                                            <v-btn
                                                :color="
                                                    chk_save_img_skip == false
                                                        ? 'amber'
                                                        : 'green accent-2'
                                                "
                                                small
                                                rounded
                                                class="ml-1 mar-t-20"
                                                v-if="
                                                    (countNumTimer > 35 &&
                                                        chk_save_img ==
                                                            false) ||
                                                        chk_save_img_skip ==
                                                            true
                                                "
                                                @click="Skip_Upload()"
                                            >
                                                <b>Skip Upload</b>
                                            </v-btn>

                                            <v-btn
                                                x-small
                                                fab
                                                color="green accent-2"
                                                class="ml-1 mar-t-20"
                                                v-if="
                                                    chk_save_step == 2 &&
                                                        chk_save_img == true &&
                                                        chk_save_img_skip ==
                                                            false
                                                "
                                            >
                                                <v-icon>mdi-check</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <div id="step-1" v-if="chk_save_step === 1">
                                        <v-row>
                                            <v-col cols="6">
                                                <div
                                                    id="my-strictly-unique-vue-upload-multiple-image"
                                                    style="text-align: center"
                                                >
                                                    <vue-upload-multiple-image
                                                        @upload-success="
                                                            uploadImageSuccess
                                                        "
                                                        @before-remove="
                                                            beforeRemove
                                                        "
                                                        @edit-image="editImage"
                                                        @data-change="
                                                            dataChange
                                                        "
                                                        dragText="UPLOAD"
                                                        browseText="CSO"
                                                        primaryText="cso image"
                                                        markIsPrimaryText="จัดลำดับรูปภาพ"
                                                        idUpload="myIdUpload1"
                                                        editUpload="myIdEdit1"
                                                        :maxImage="50"
                                                        :rules="
                                                            e_cso == 'N'
                                                                ? myIdUpload1
                                                                : []
                                                        "
                                                    ></vue-upload-multiple-image>
                                                    <span
                                                        class="text-color-red font-fix-13"
                                                        v-if="chk_cso === true"
                                                        >** CSO Upload is
                                                        required</span
                                                    >
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                v-if="
                                                    product_group !=
                                                        'Printing' &&
                                                        chk_pj == 'CDAX'
                                                "
                                            >
                                                <div
                                                    id="2"
                                                    style="text-align: center"
                                                >
                                                    <vue-upload-multiple-image
                                                        @upload-success="
                                                            uploadImageSuccess2
                                                        "
                                                        @before-remove="
                                                            beforeRemove2
                                                        "
                                                        @edit-image="editImage2"
                                                        @data-change="
                                                            dataChange2
                                                        "
                                                        dragText="UPLOAD"
                                                        browseText="
                                                UEFI
                                            "
                                                        primaryText="uefi image"
                                                        markIsPrimaryText="จัดลำดับรูปภาพ"
                                                        idUpload="myIdUpload2"
                                                        editUpload="myIdEdit2"
                                                        :maxImage="50"
                                                    ></vue-upload-multiple-image>
                                                </div>
                                            </v-col>
                                            <v-col cols="6">
                                                <div
                                                    id="2"
                                                    style="text-align: center"
                                                >
                                                    <vue-upload-multiple-image
                                                        @upload-success="
                                                            uploadImageSuccess3
                                                        "
                                                        @before-remove="
                                                            beforeRemove3
                                                        "
                                                        @edit-image="editImage3"
                                                        @data-change="
                                                            dataChange3
                                                        "
                                                        dragText="UPLOAD"
                                                        browseText="ATTACH"
                                                        primaryText="attach image"
                                                        markIsPrimaryText="จัดลำดับรูปภาพ"
                                                        idUpload="myIdUpload3"
                                                        editUpload="myIdEdit3"
                                                        :maxImage="50"
                                                    ></vue-upload-multiple-image>
                                                    <span
                                                        class="text-color-red font-fix-13"
                                                        v-if="
                                                            chk_attach === true
                                                        "
                                                        >** ATTACH Upload is
                                                        required</span
                                                    >
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row justify="center">
                                            <v-col cols="10" class="mar-t-10">
                                                <v-progress-linear
                                                    v-if="
                                                        chk_save_data_img ==
                                                            true
                                                    "
                                                    indeterminate
                                                    color="cyan"
                                                ></v-progress-linear>
                                                <v-btn
                                                    v-if="
                                                        chk_save_data_img ==
                                                            false
                                                    "
                                                    color="success"
                                                    block
                                                    @click="
                                                        save_close_case_img()
                                                    "
                                                    :disabled="!valid"
                                                    ><v-icon small class="mr-1"
                                                        >mdi-content-save</v-icon
                                                    >
                                                    Save</v-btn
                                                >
                                            </v-col>

                                            <v-col cols="10" class="mar-t-10">
                                                <v-btn block @click="back()"
                                                    ><v-icon small class="mr-1"
                                                        >mdi-arrow-left-bold-circle-outline</v-icon
                                                    >
                                                    Back</v-btn
                                                >
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <div id="step-2" v-if="chk_save_step === 2">
                                        <v-row justify="center">
                                            <v-col cols="10">
                                                <v-chip>
                                                    <b>
                                                        Step 2 : Upload Data
                                                        Case
                                                    </b>
                                                </v-chip>
                                            </v-col>
                                        </v-row>

                                        <v-row justify="center">
                                            <v-col cols="10">
                                                <v-select
                                                    dense
                                                    outlined
                                                    :items="en_item"
                                                    item-text="text"
                                                    item-value="id"
                                                    label="Job Status"
                                                    v-model="
                                                        form_1.engineer_status
                                                    "
                                                    :rules="engineer_statusR"
                                                    required
                                                    @change="func_chk_status()"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            v-if="
                                                data_eeg1.show_ismart == 'Y' &&
                                                    data_eeg1.skip_ismart ==
                                                        'N' &&
                                                    data_eeg1.project_name ==
                                                        'CDAX' &&
                                                    chk_local_status == 'Y'
                                            "
                                            justify="center"
                                            class="mar-t-20"
                                        >
                                            <v-col cols="10">
                                                <v-autocomplete
                                                    dense
                                                    outlined
                                                    menu-props="auto"
                                                    label="Local Status"
                                                    :items="local_status_item"
                                                    v-model="local_status"
                                                    :rules="local_statusR"
                                                ></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            justify="center"
                                            class="mar-t-20"
                                            v-if="
                                                (form_1.engineer_status ===
                                                    'PUR_M' &&
                                                    chk_pj === 'CDAX') ||
                                                    (form_1.engineer_status ===
                                                        'Complete' &&
                                                        chk_pj === 'HPE')
                                            "
                                        >
                                            <v-col
                                                cols="10"
                                                class="text-center"
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    :label="
                                                        form_1.engineer_status ===
                                                            'PUR_M' &&
                                                        chk_pj === 'CDAX'
                                                            ? 'SN เครื่องลูกค้า'
                                                            : 'Old Unit Serial'
                                                    "
                                                    v-model="form_1.sn_old"
                                                    :rules="sn_oldR"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="10"
                                                class="text-center mar-t-20"
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    :label="
                                                        form_1.engineer_status ===
                                                            'PUR_M' &&
                                                        chk_pj === 'CDAX'
                                                            ? 'SN ตัววาง Same'
                                                            : 'New Unit Serial '
                                                    "
                                                    v-model="form_1.sn_new"
                                                    :rules="sn_newR"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="10"
                                                class="text-center mar-t-20"
                                                v-if="
                                                    form_1.engineer_status ===
                                                        'PUR_M' &&
                                                        chk_pj === 'CDAX'
                                                "
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="Same Item No."
                                                    v-model="form_1.sameitem_no"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            class="mar-t-20 mb-2"
                                            justify="center"
                                            v-if="
                                                form_1.engineer_status ===
                                                    'Complete'
                                            "
                                        >
                                            <v-col
                                                cols="10"
                                                class="text-center"
                                            >
                                                ลูกค้าพึงพอใจกับการบริการครั้งนี้หรือไม่
                                            </v-col>
                                            <v-col
                                                cols="10"
                                                class="text-center mar-t-20"
                                            >
                                                <img
                                                    :class="
                                                        form_1.customer_level ===
                                                        'L'
                                                            ? 'fix-png-a clik-cor red '
                                                            : 'fix-png-a'
                                                    "
                                                    src="../../../assets/all/sad.png"
                                                    @click="cick_cus('L')"
                                                />
                                                <img
                                                    class=""
                                                    :class="
                                                        form_1.customer_level ===
                                                        'M'
                                                            ? 'fix-png-a ml-2 mr-2 clik-cor yellow '
                                                            : 'fix-png-a ml-2 mr-2'
                                                    "
                                                    src="../../../assets/all/face.png"
                                                    @click="cick_cus('M')"
                                                />
                                                <img
                                                    :class="
                                                        form_1.customer_level ===
                                                        'H'
                                                            ? 'fix-png-a clik-cor teal accent-3'
                                                            : 'fix-png-a'
                                                    "
                                                    src="../../../assets/all/smile.png"
                                                    @click="cick_cus('H')"
                                                />
                                            </v-col>
                                            <v-col
                                                cols="10"
                                                class="text-center mar-t-20"
                                                v-if="
                                                    chk_customer_level === true
                                                "
                                            >
                                                <span
                                                    class="text-color-red font-fix-13"
                                                    >** Customer level is
                                                    required</span
                                                >
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            justify="center"
                                            class="mar-t-30"
                                            v-if="
                                                form_1.engineer_status ===
                                                    'Incomplete' &&
                                                    chk_pj === 'CDAX'
                                            "
                                        >
                                            <v-col
                                                cols="10"
                                                class="text-center"
                                            >
                                                <v-radio-group
                                                    v-model="form_1.quotation"
                                                    :rules="quotationR"
                                                    required
                                                    row
                                                >
                                                    <v-radio
                                                        label="เสนอราคา"
                                                        value="Y"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ไม่เสนอราคา"
                                                        value="N"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            v-if="
                                                chk_fid === true &&
                                                    form_1.engineer_status ===
                                                        'Complete'
                                            "
                                            justify="center"
                                            class="mt-2"
                                        >
                                            <v-col cols="10">
                                                <v-radio-group
                                                    v-model="form_1.fid"
                                                    :rules="fidR"
                                                    required
                                                    row
                                                >
                                                    <v-radio
                                                        label="มี UEFI"
                                                        value="Y"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ไม่มี UEFI"
                                                        value="N"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                            <v-col cols="10" class="mar-t-30">
                                                <v-text-field
                                                    outlined
                                                    v-if="form_1.fid === 'Y'"
                                                    dense
                                                    label="ระบุ UEFI"
                                                    v-model="form_1.fid_text"
                                                    :maxlength="27"
                                                    :counter="27"
                                                    @keyup="checkfid_text()"
                                                    :rules="fid_textR"
                                                    required
                                                >
                                                </v-text-field>
                                                <v-combobox
                                                    v-if="form_1.fid === 'N'"
                                                    :items="[
                                                        'PND - Part detected โดยระบบไม่ได้ เช่น No Power',
                                                        'DHU - โปรแกรม diagnostic ค้าง หรือ ไม่สำเร็จ',
                                                        'PPR - พาร์ทที่เทส UEFI ผ่านแต่ยังต้องเปลี่ยนแปลง HDD เรื่องจากยังมีอาการอยู่',
                                                        'CNR - ลูกค้าไม่สะดวกให้เทส',
                                                    ]"
                                                    dense
                                                    outlined
                                                    label="ระบุ UEFI"
                                                    v-model="form_1.fid_text"
                                                    :rules="fid_textRR"
                                                ></v-combobox>
                                                <!-- <v-text-field
                                                    outlined
                                                    v-if="form_1.fid === 'N'"
                                                    dense
                                                    label="ระบุเหตุผล"
                                                    v-model="form_1.fid_text"
                                                    :rules="fid_textRR"
                                                    required
                                                ></v-text-field> -->
                                            </v-col>
                                        </v-row>

                                        <v-row justify="center">
                                            <!-- START Kbank -->
                                            <v-col
                                                class="mar-t-30"
                                                cols="10"
                                                v-if="chk_pj === 'KBANK'"
                                                ><b>New Toner</b></v-col
                                            >

                                            <v-col
                                                v-if="chk_pj === 'KBANK'"
                                                cols="10"
                                                class="mar-t-10"
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="SN"
                                                    v-model="form_1.sn"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="10"
                                                class="mar-t-30"
                                                v-if="chk_pj === 'KBANK'"
                                                ><b>Old Toner</b></v-col
                                            >
                                            <v-col
                                                v-if="chk_pj === 'KBANK'"
                                                cols="5"
                                                class="mar-t-10"
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="%"
                                                    v-model="form_1.persend"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                v-if="chk_pj === 'KBANK'"
                                                cols="5"
                                                class="mar-t-10"
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="Page Remaining"
                                                    v-model="
                                                        form_1.page_remaining
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                v-if="chk_pj === 'KBANK'"
                                                cols="10"
                                                class="mar-t-30"
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="Page Print with this supply"
                                                    v-model="
                                                        form_1.page_printer
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <!-- END Kbank -->
                                        </v-row>

                                        <v-row
                                            justify="center"
                                            class="mar-t-20"
                                            v-for="(row_part,
                                            nums) in data_part"
                                            :key="nums"
                                        >
                                            <v-col cols="10" class="mt-1">
                                                <span
                                                    class="primary--text ml-3"
                                                >
                                                    {{ row_part.ponumber }}
                                                </span>
                                                <br />
                                                <v-chip dense>
                                                    <strong>{{
                                                        row_part.part_name
                                                    }}</strong>
                                                    <span
                                                        class="ml-2 font-weight-light text-lowercase"
                                                    >
                                                        {{
                                                            row_part.part_description
                                                        }}
                                                    </span>
                                                </v-chip>

                                                <v-select
                                                    class="mt-6"
                                                    dense
                                                    outlined
                                                    :items="
                                                        row_part.status !=
                                                        'Back Order'
                                                            ? part_item
                                                            : part_backorder_item
                                                    "
                                                    item-text="text"
                                                    item-value="id"
                                                    label="Status part"
                                                    v-model="
                                                        form_1.part[
                                                            'P' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                    :rules="part_issue_idR"
                                                    required
                                                    @change="
                                                        func_failure_code_statte(
                                                            form_1.part,
                                                            row_part.part_issue_id
                                                        )
                                                    "
                                                ></v-select>
                                            </v-col>

                                            <v-col
                                                cols="10"
                                                class="mar-t-20"
                                                v-if="
                                                    form_1.part[
                                                        'P' +
                                                            row_part.part_issue_id
                                                    ] === 'Bad' &&
                                                        (chk_pj != 'SRFR' ||
                                                            (chk_pj ===
                                                                'SRFR' &&
                                                                row_part.inv_status !=
                                                                    'stock')) &&
                                                        check_mo(
                                                            row_part.ponumber
                                                        ) == 'MO'
                                                "
                                            >
                                                <div
                                                    v-if="
                                                        data_eeg1.show_ismart ==
                                                            'Y' &&
                                                            data_eeg1.skip_ismart ==
                                                                'N' &&
                                                            data_eeg1.project_name ==
                                                                'CDAX'
                                                    "
                                                    justify="center"
                                                >
                                                    Return Override Flag
                                                    <v-radio-group
                                                        class="mar-t-03"
                                                        v-model="
                                                            form_1.overa[
                                                                'overa' +
                                                                    row_part.part_issue_id
                                                            ]
                                                        "
                                                        required
                                                        row
                                                    >
                                                        <!-- :rules="return_flagR1" -->
                                                        <v-radio
                                                            label="No"
                                                            value="No"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="Yes"
                                                            value=""
                                                        ></v-radio>
                                                    </v-radio-group>

                                                    <v-autocomplete
                                                        v-if="
                                                            form_1.overa[
                                                                'overa' +
                                                                    row_part.part_issue_id
                                                            ] == 'Yes'
                                                        "
                                                        dense
                                                        outlined
                                                        menu-props="auto"
                                                        label="Return Override Reason"
                                                        :items="[
                                                            'Customer buy back defective',
                                                            'DMR entitlement coverage',
                                                            'Special HP Approval',
                                                        ]"
                                                        v-model="
                                                            form_1.overb[
                                                                'overb' +
                                                                    row_part.part_issue_id
                                                            ]
                                                        "
                                                        @input="func_primary(1)"
                                                        :rules="
                                                            form_1.overa[
                                                                'overa' +
                                                                    row_part.part_issue_id
                                                            ] == 'Yes'
                                                                ? return_flagR2
                                                                : ''
                                                        "
                                                    ></v-autocomplete>
                                                </div>
                                            </v-col>

                                            <v-col
                                                cols="10"
                                                class="mar-t-20 fix-flex-end-row"
                                                v-if="
                                                    (form_1.part[
                                                        'P' +
                                                            row_part.part_issue_id
                                                    ] === 'Bad' ||
                                                        form_1.part[
                                                            'P' +
                                                                row_part.part_issue_id
                                                        ] === 'DOA') &&
                                                        (chk_pj != 'SRFR' ||
                                                            (chk_pj ===
                                                                'SRFR' &&
                                                                row_part.inv_status !=
                                                                    'stock'))
                                                "
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="CT เก่า"
                                                    v-model="
                                                        form_1.ct_old[
                                                            'CTO' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col
                                                cols="10"
                                                class="mar-t-20 fix-flex-end-row"
                                                v-if="
                                                    (form_1.part[
                                                        'P' +
                                                            row_part.part_issue_id
                                                    ] === 'Bad' ||
                                                        form_1.part[
                                                            'P' +
                                                                row_part.part_issue_id
                                                        ] === 'DOA') &&
                                                        (chk_pj != 'SRFR' ||
                                                            (chk_pj ===
                                                                'SRFR' &&
                                                                row_part.inv_status !=
                                                                    'stock'))
                                                "
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="CT ใหม่"
                                                    v-model="
                                                        form_1.ct_new[
                                                            'CTN' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <!-- Start StreamBarcodeReader -->
                                            <div
                                                v-if="
                                                    chk_bracode[
                                                        'CT_OLD' +
                                                            row_part.part_issue_id
                                                    ] === true
                                                "
                                                class="no-pd mb-4 mar-t-10"
                                            >
                                                <StreamBarcodeReader
                                                    @decode="on_ct_old_barcode"
                                                    @loaded="onLoaded"
                                                ></StreamBarcodeReader>
                                            </div>
                                            <div
                                                v-if="
                                                    chk_bracode[
                                                        'CT_NEW' +
                                                            row_part.part_issue_id
                                                    ] === true
                                                "
                                                class="no-pd mb-4 mar-t-10"
                                            >
                                                <StreamBarcodeReader
                                                    @decode="on_ct_new_barcode"
                                                    @loaded="onLoaded"
                                                ></StreamBarcodeReader>
                                            </div>
                                            <!-- End StreamBarcodeReader -->

                                            <!-- Start ImageBarcodeReader -->
                                            <div
                                                v-if="
                                                    chk_bracode[
                                                        'CT_OLD_IMG' +
                                                            row_part.part_issue_id
                                                    ] === true
                                                "
                                                class="no-pd mb-4 mar-t-10"
                                            >
                                                <ImageBarcodeReader
                                                    class="mb-3"
                                                    @decode="on_ct_old_barcode"
                                                    @error="onError"
                                                ></ImageBarcodeReader>
                                            </div>
                                            <div
                                                v-if="
                                                    chk_bracode[
                                                        'CT_NEW_IMG' +
                                                            row_part.part_issue_id
                                                    ] === true
                                                "
                                                class="no-pd mb-4 mar-t-10"
                                            >
                                                <ImageBarcodeReader
                                                    class="mb-3"
                                                    @decode="on_ct_new_barcode"
                                                    @error="onError"
                                                ></ImageBarcodeReader>
                                            </div>
                                            <!-- End ImageBarcodeReader -->
                                            <v-col
                                                cols="8"
                                                class="mar-t-20"
                                                v-if="
                                                    row_part.inv_status ===
                                                        'stock' &&
                                                        row_part.status !=
                                                            'Back Order'
                                                "
                                            >
                                                <v-text-field
                                                    :disabled="
                                                        form_1.part[
                                                            'P' +
                                                                row_part.part_issue_id
                                                        ] === 'Good' &&
                                                            (row_part.part_name ==
                                                                'M0H50' ||
                                                                row_part.part_name ==
                                                                    'M0H51' ||
                                                                row_part.part_name ==
                                                                    'X4E75' ||
                                                                row_part.part_name ==
                                                                    'M0H50 Color' ||
                                                                row_part.part_name ==
                                                                    'M0H51 Black' ||
                                                                row_part.part_name ==
                                                                    'X4E75 Black')
                                                    "
                                                    outlined
                                                    dense
                                                    label="Singlepart"
                                                    v-model="
                                                        form_1.singlepart[
                                                            'PART' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                    :rules="
                                                        form_1.part[
                                                            'P' +
                                                                row_part.part_issue_id
                                                        ] === 'Good' ||
                                                        row_part.vendor == 'Y'
                                                            ? []
                                                            : singlepartR
                                                    "
                                                    @input="
                                                        checksinglepart(
                                                            row_part.part_issue_id
                                                        )
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col
                                                cols="2"
                                                v-if="
                                                    row_part.inv_status ===
                                                        'stock'
                                                "
                                            >
                                                <v-speed-dial
                                                    class="mar-t-20"
                                                    v-model="
                                                        chk_bracode[
                                                            'SG' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                    :direction="direction"
                                                    transition="slide-y-reverse-transition"
                                                >
                                                    <template v-slot:activator>
                                                        <v-btn
                                                            @click="
                                                                ;(chk_bracode[
                                                                    'BARCODE' +
                                                                        row_part.part_issue_id
                                                                ] = false),
                                                                    (chk_bracode[
                                                                        'BARCODE_IMG' +
                                                                            row_part.part_issue_id
                                                                    ] = false)
                                                            "
                                                            v-model="
                                                                chk_bracode[
                                                                    'SG' +
                                                                        row_part.part_issue_id
                                                                ]
                                                            "
                                                            :color="
                                                                chk_bracode[
                                                                    'BARCODE' +
                                                                        row_part.part_issue_id
                                                                ] === true ||
                                                                chk_bracode[
                                                                    'BARCODE_IMG' +
                                                                        row_part.part_issue_id
                                                                ] === true
                                                                    ? 'green accent-3'
                                                                    : 'white'
                                                            "
                                                            dark
                                                            small
                                                            fab
                                                        >
                                                            <v-icon
                                                                v-if="
                                                                    chk_bracode[
                                                                        'SG' +
                                                                            row_part.part_issue_id
                                                                    ]
                                                                "
                                                                color="blue-grey darken-1"
                                                                >mdi-close</v-icon
                                                            >
                                                            <v-icon
                                                                v-else
                                                                color="light-blue darken-4"
                                                                >mdi-barcode-scan</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <v-btn
                                                        fab
                                                        dark
                                                        small
                                                        color="teal"
                                                        @click="
                                                            open_barcode(
                                                                row_part.part_issue_id,
                                                                'img'
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            >mdi-image</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        fab
                                                        dark
                                                        small
                                                        color="cyan"
                                                        @click="
                                                            open_barcode(
                                                                row_part.part_issue_id,
                                                                'scan'
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            >mdi-barcode-scan</v-icon
                                                        >
                                                    </v-btn>
                                                </v-speed-dial>
                                            </v-col>

                                            <div
                                                v-if="
                                                    chk_bracode[
                                                        'BARCODE' +
                                                            row_part.part_issue_id
                                                    ] === true
                                                "
                                                class="no-pd mb-4 mar-t-10"
                                            >
                                                <StreamBarcodeReader
                                                    @decode="onDecode"
                                                    @loaded="onLoaded"
                                                ></StreamBarcodeReader>
                                            </div>

                                            <div
                                                v-if="
                                                    chk_bracode[
                                                        'BARCODE_IMG' +
                                                            row_part.part_issue_id
                                                    ] === true
                                                "
                                            >
                                                <ImageBarcodeReader
                                                    class="mb-3"
                                                    @decode="onDecode"
                                                    @error="onError"
                                                ></ImageBarcodeReader>
                                            </div>
                                            <div
                                                style="margin-bottom: 15px; margin-top: -12px;"
                                                v-if="
                                                    form_1.singlepart[
                                                        'PART_TEXT' +
                                                            row_part.part_issue_id
                                                    ] != ''
                                                "
                                            >
                                                <b
                                                    class="mar-t-10"
                                                    style="color: red"
                                                    >{{
                                                        "ไม่พบ Singlepart : " +
                                                            form_1.singlepart[
                                                                "PART_TEXT" +
                                                                    row_part.part_issue_id
                                                            ] +
                                                            " นี้ในระบบ"
                                                    }}
                                                </b>
                                            </div>
                                        </v-row>

                                        <v-row
                                            v-if="chk_pj == 'SRFR'"
                                            justify="center"
                                            class="mar-t-30"
                                        >
                                            <v-col cols="10">
                                                <v-chip color="lime accent-3"
                                                    ><b
                                                        >ใช้ Part เพิ่มเติม</b
                                                    ></v-chip
                                                >
                                                <v-btn
                                                    class="ml-2"
                                                    color="lime accent-3"
                                                    fab
                                                    small
                                                    @click="
                                                        open_add_part_srfr()
                                                    "
                                                >
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </v-col>

                                            <v-col
                                                class="mar-t-15"
                                                cols="10"
                                                v-for="(row_data_case_part,
                                                index_data_case_part) in form_1.case_part"
                                                :key="index_data_case_part"
                                            >
                                                <v-chip
                                                    color="lime accent-1"
                                                    class="mr-1"
                                                    ><b
                                                        >{{
                                                            index_data_case_part +
                                                                1
                                                        }}.{{
                                                            row_data_case_part.part_description
                                                        }}</b
                                                    ></v-chip
                                                >
                                                <v-chip color="lime accent-1"
                                                    ><b>{{
                                                        row_data_case_part.status
                                                    }}</b></v-chip
                                                >
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            v-if="case_team_name == 'NONHP'"
                                            justify="center"
                                            class="mar-t-30"
                                        >
                                            <v-col cols="10">
                                                <v-radio-group
                                                    v-model="checkbox"
                                                    :rules="checkboxR"
                                                    @input="clear_part('N')"
                                                >
                                                    <v-radio
                                                        label="ไม่ใช้ Part เพิ่มเติม"
                                                        value="N"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ใช้ Part เพิ่มเติม"
                                                        value="Y"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                            <v-col
                                                class="mar-t-30"
                                                cols="10"
                                                v-if="checkbox == 'Y'"
                                            >
                                                <v-chip color="lime accent-3"
                                                    ><b
                                                        >ใส่ Singlepart</b
                                                    ></v-chip
                                                >
                                                <v-btn
                                                    class="ml-2"
                                                    color="lime accent-3"
                                                    fab
                                                    small
                                                    @click="open_add_part()"
                                                >
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </v-col>

                                            <v-col
                                                class="mar-t-15"
                                                cols="10"
                                                v-if="checkbox == 'Y'"
                                            >
                                                <div
                                                    v-for="(row_data_case_part,
                                                    index_data_case_part) in form_1.case_part"
                                                    :key="index_data_case_part"
                                                >
                                                    <v-chip
                                                        color="lime accent-1"
                                                        class="mr-1 mt-1"
                                                        ><b
                                                            >{{
                                                                index_data_case_part +
                                                                    1
                                                            }}.{{
                                                                row_data_case_part.singlepart
                                                            }}</b
                                                        ></v-chip
                                                    >
                                                    <v-chip
                                                        color="lime accent-1"
                                                        class="mt-1"
                                                        ><b>{{
                                                            row_data_case_part.status
                                                        }}</b></v-chip
                                                    >
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            v-if="
                                                data_eeg1.show_ismart == 'Y' &&
                                                    data_eeg1.skip_ismart ==
                                                        'N' &&
                                                    data_eeg1.project_name ==
                                                        'CDAX' &&
                                                    show_nmu == 'Y' &&
                                                    product_group ==
                                                        'Computing' &&
                                                    form_1.engineer_status ===
                                                        'Complete'
                                            "
                                            justify="center"
                                        >
                                            <v-col cols="10" class="mar-t-15">
                                                <v-autocomplete
                                                    dense
                                                    outlined
                                                    menu-props="auto"
                                                    label="NMU Primary"
                                                    :items="primary_item"
                                                    v-model="nmu.primary"
                                                    @input="func_primary(1)"
                                                    :rules="nmu_1"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="10" class="mar-t-15">
                                                <v-autocomplete
                                                    dense
                                                    outlined
                                                    menu-props="auto"
                                                    label="NMU Secondary"
                                                    :items="secondary_item"
                                                    v-model="nmu.secondary"
                                                    :disabled="
                                                        secondary_item.length ==
                                                            0
                                                    "
                                                    :rules="nmu_2"
                                                    @input="func_primary(2)"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="10" class="mar-t-15">
                                                <v-autocomplete
                                                    dense
                                                    outlined
                                                    menu-props="auto"
                                                    label="NMU Resolution Note (Auto Capture)"
                                                    :items="resolution_item"
                                                    v-model="nmu.resolution"
                                                    :rules="nmu_3"
                                                    :disabled="
                                                        resolution_item.length ==
                                                            0
                                                    "
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col
                                                cols="10"
                                                class="mar-t-15"
                                                v-if="
                                                    this.nmu.secondary ==
                                                        'Type Version'
                                                "
                                            >
                                                <v-text-field
                                                    @input="func_primary()"
                                                    label="Type Version Manually"
                                                    dense
                                                    outlined
                                                    v-model="nmu.version"
                                                    :rules="nmu_4"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            justify="center"
                                            class="mar-t-20"
                                        >
                                            <v-col cols="5" class="mt-3">
                                                Time Start
                                                <vue-timepicker
                                                    :rules="startR"
                                                    v-model="form_1.start"
                                                    class="mt-1"
                                                ></vue-timepicker>
                                            </v-col>

                                            <v-col cols="5" class="mt-3">
                                                Time Stop
                                                <vue-timepicker
                                                    v-model="form_1.stop"
                                                    :rules="stopR"
                                                    :disabled="
                                                        team_name == 'ONSITE'
                                                    "
                                                    class="mt-1"
                                                ></vue-timepicker>
                                            </v-col>

                                            <v-col cols="10">
                                                <v-text-field
                                                    outlined
                                                    label="Csono"
                                                    v-model="form_1.csono"
                                                    dense
                                                    :rules="
                                                        e_cso == 'N'
                                                            ? csonoR
                                                            : []
                                                    "
                                                ></v-text-field>
                                            </v-col>

                                            <v-col
                                                cols="10"
                                                class="mar-t-30"
                                                v-if="
                                                    (chk_pj == 'CDAX' ||
                                                        chk_pj == 'S-Print' ||
                                                        chk_pj == 'SRFR') &&
                                                        form_1.engineer_status ===
                                                            'Complete'
                                                "
                                            >
                                                <v-combobox
                                                    :items="data_symptom"
                                                    v-model="form_1.ce_symptom"
                                                    label="อาการเสียที่พบ (ภาษาอังกฤษ)"
                                                    :rules="ce_symptomR"
                                                    dense
                                                    outlined
                                                ></v-combobox>
                                            </v-col>

                                            <v-col cols="10" class="mar-t-30">
                                                <!-- @keyup="uppercase()" -->
                                                <div
                                                    v-if="
                                                        chk_pj == 'CDAX' ||
                                                            chk_pj ==
                                                                'S-Print' ||
                                                            chk_pj == 'SRFR'
                                                    "
                                                >
                                                    <v-combobox
                                                        :items="data_solution"
                                                        v-model="
                                                            form_1.solution
                                                        "
                                                        label="Solution.."
                                                        :rules="solutionR"
                                                        dense
                                                        outlined
                                                    ></v-combobox>
                                                </div>
                                                <div v-else>
                                                    <v-textarea
                                                        outlined
                                                        label="Solution.."
                                                        background-color="#FFFF"
                                                        rows="3"
                                                        :rules="solutionR"
                                                        v-model="
                                                            form_1.solution
                                                        "
                                                    ></v-textarea>
                                                    <b
                                                        v-if="chk_pj == 'SRFR'"
                                                        style="color: #ff5c5c"
                                                    >
                                                        ** ถ้ามีการใช้ part norm
                                                        ของ srfr ให้ระบุลง
                                                        Solution ด้วย
                                                    </b>
                                                </div>
                                            </v-col>

                                            <v-col
                                                cols="10"
                                                v-if="
                                                    form_1.engineer_status ===
                                                        'Complete' &&
                                                        product_group ===
                                                            'Printing'
                                                "
                                            >
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="Print Count"
                                                    v-model="form_1.printcount"
                                                    :rules="chk_print_count()"
                                                    required
                                                ></v-text-field>
                                            </v-col>

                                            <v-col
                                                cols="10"
                                                :class="
                                                    chk_pj == 'SRFR'
                                                        ? 'text-center'
                                                        : 'mar-t-30 text-center'
                                                "
                                            >
                                                <v-chip color="amber">
                                                    <b
                                                        >Cus. Email :
                                                        {{ customer_email }}
                                                    </b></v-chip
                                                >
                                            </v-col>

                                            <v-col cols="10" class="mar-t-10">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    label="Email"
                                                    background-color="#FFFF"
                                                    v-model="form_1.email"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col
                                                class="mar-t-10"
                                                cols="12"
                                                style="
                                                    background-color: #e1f5ff;
                                                "
                                                v-if="showMap === true"
                                            >
                                                <v-progress-linear
                                                    v-if="show_address === ''"
                                                    indeterminate
                                                    color="cyan"
                                                ></v-progress-linear>
                                                <div id="app">
                                                    <gmap-map
                                                        v-show="showMap"
                                                        ref="map"
                                                        id="map"
                                                        :center="mapEnd"
                                                        :zoom="11"
                                                        style="
                                                            width: 100%;
                                                            height: 200px;
                                                        "
                                                    >
                                                        <DirectionsRenderer
                                                            @dragend="
                                                                getDirection
                                                            "
                                                        />
                                                    </gmap-map>
                                                </div>
                                            </v-col>

                                            <!-- ปิดตรงนี้เนื่องจากต้องการลดปริมาณการใช้ google map api -->
                                            <!-- <v-col
                                            class="mar-t-10 div-scoll"
                                            cols="5"
                                            v-if="showMap === true"
                                        >
                                            <v-progress-linear
                                                v-if="show_address === ''"
                                                indeterminate
                                                color="cyan"
                                            ></v-progress-linear>
                                            <div v-if="show_address != ''">
                                                <div
                                                    v-for="(n,
                                                    index_center_p) in data_center_point"
                                                    :key="index_center_p"
                                                    class="cur-p"
                                                >
                                                    <p
                                                        @click="
                                                            add_gps(
                                                                index_center_p
                                                            )
                                                        "
                                                        class="cup-p"
                                                        color="primary"
                                                    >
                                                        <b
                                                            style="color: #2c5aa3"
                                                        >
                                                            {{
                                                                index_center_p +
                                                                    1 +
                                                                    ". " +
                                                                    n.name
                                                            }}</b
                                                        >
                                                    </p>
                                                </div>
                                            </div>
                                        </v-col> -->

                                            <v-col
                                                cols="12"
                                                style="background-color: #e1f5ff;border-top: 1px solid#c2eafd;
                                                "
                                                v-if="showMap === true"
                                            >
                                                <span style="color: #2c5aa3">{{
                                                    show_address
                                                }}</span>

                                                <span
                                                    style="color: #2c5aa3"
                                                    v-if="show_address == ''"
                                                    class="ml-2"
                                                >
                                                    <b
                                                        >**สามารถ Save ก่อนได้
                                                        ไม่ต้องรอ Map load
                                                        เสร็จ</b
                                                    >
                                                </span>
                                            </v-col>

                                            <v-col cols="10">
                                                <v-progress-linear
                                                    v-if="chk_save_data == true"
                                                    indeterminate
                                                    color="cyan"
                                                ></v-progress-linear>
                                                <v-btn
                                                    v-if="
                                                        chk_save_data == false
                                                    "
                                                    color="success"
                                                    block
                                                    @click="save_close_case()"
                                                    :disabled="
                                                        !valid ||
                                                            chk_save_img ==
                                                                false ||
                                                            (checkbox == 'Y' &&
                                                                form_1.case_part
                                                                    .length ==
                                                                    0)
                                                    "
                                                    ><v-icon small class="mr-1"
                                                        >mdi-content-save</v-icon
                                                    >
                                                    Save</v-btn
                                                >
                                            </v-col>

                                            <v-col cols="10" class="mar-t-10">
                                                <v-btn
                                                    block
                                                    v-on:click.stop="back_2()"
                                                    ><v-icon small class="mr-1"
                                                        >mdi-arrow-left-bold-circle-outline</v-icon
                                                    >
                                                    Back</v-btn
                                                >
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>

                                <!-- End -- chk_form_action === 1 -->
                            </v-form>
                        </div>

                        <!-- new function  -->
                        <!-- show_rate == false && show_sign == false && show_ismart == false -->
                        <div v-if="show_rate == true || show_sign == true">
                            <Signature
                                pages="onsite"
                                :e_email="e_email"
                                :data_sign="data_sign"
                                :show_rate="show_rate"
                                :show_sign="show_sign"
                                @page_ismart="page_ismart"
                            />
                        </div>
                        <div v-if="show_ismart == true">
                            <ISmart
                                :data_ismart="data_ismart"
                                @close_page="close_dialog()"
                                :check_page="1"
                            />
                        </div>
                        <!-- end new function  -->
                    </v-card>
                </v-dialog>
            </v-row>
        </div>

        <div v-if="chkViewMain === 'return'" class="no-pd">
            <v-row class="ml-2">
                <v-col cols="12">
                    <h3 style="color: #515666">
                        RETURN DATE {{ status_onsite_at[0].onsite_date }}
                    </h3>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="12" style="background-color: #e1f5ff">
                    <v-progress-linear
                        v-if="show_address === ''"
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>
                    <div id="app">
                        <gmap-map
                            v-show="showMap"
                            ref="map"
                            id="map"
                            :center="mapStart"
                            :zoom="11"
                            style="width: 100%; height: 200px"
                        >
                            <DirectionsRenderer @dragend="getDirection" />
                        </gmap-map>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="show_address != ''">
                <v-col cols="12">
                    <v-progress-linear
                        v-if="chk_save_return == true"
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>
                    <v-btn
                        color="success"
                        block
                        @click="save_return(2)"
                        v-if="chk_save_return == false"
                        ><v-icon small class="mr-1">mdi-content-save</v-icon>
                        Save</v-btn
                    >
                </v-col>
            </v-row>
        </div>

        <div v-if="chkViewMain === 'complete'" class="no-pd">
            <v-row class="ml-2">
                <v-col cols="12" class="text-center">
                    <v-chip color="teal accent-3">
                        ONSITE COMPLETE {{ form_2.date }}
                    </v-chip>
                </v-col>
            </v-row>
        </div>

        <!-- Add part case -->
        <v-row justify="center">
            <v-form method="post" id="nativeForm" v-model="valid_case_part">
                <v-dialog
                    v-model="dialog_app_part"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dense dark color="primary">
                            <v-btn
                                icon
                                dark
                                @click="close_dialog_app_part()"
                                :disabled="!valid_case_part"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>

                            <v-toolbar-title>
                                <v-row>
                                    <v-col cols="10">
                                        <b>Add Singlepart</b>
                                    </v-col>
                                </v-row>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="10">
                                    <v-text-field
                                        outlined
                                        dense
                                        label="Singlepart"
                                        v-model="case_part.part"
                                        @input="
                                            checksinglepart_casepart(
                                                case_part.part
                                            )
                                        "
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        fab
                                        small
                                        :color="
                                            case_part.barcode == false
                                                ? ''
                                                : 'cyan'
                                        "
                                        @click="
                                            case_part.barcode = !case_part.barcode
                                        "
                                    >
                                        <v-icon>mdi-barcode-scan</v-icon>
                                    </v-btn>
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="case_part.barcode == true"
                                >
                                    <StreamBarcodeReader
                                        @barcode="gen_barcode_add_part"
                                        :direction="direction"
                                    />
                                </v-col>
                            </v-row>

                            <div v-if="form_1.case_part.length > 0">
                                <v-row
                                    :class="
                                        index_case_part > 0 ? 'mar-t-25' : ''
                                    "
                                    v-for="(row_case_part,
                                    index_case_part) in form_1.case_part"
                                    :key="index_case_part"
                                >
                                    <v-col cols="4">
                                        <v-chip color="amber"
                                            >{{ index_case_part + 1 }}.{{
                                                row_case_part.singlepart
                                            }}</v-chip
                                        >
                                    </v-col>
                                    <v-col cols="6" class="mar-t-25">
                                        <v-select
                                            class="mt-6"
                                            dense
                                            outlined
                                            :items="part_item"
                                            item-text="text"
                                            item-value="id"
                                            label="Status part"
                                            v-model="row_case_part.status"
                                            required
                                            :rules="statusR"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn
                                            small
                                            fab
                                            color="red accent-2"
                                            @click="
                                                del_case_part(row_case_part)
                                            "
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-row>
        <v-row justify="center">
            <v-form
                method="post"
                id="nativeForm"
                v-model="valid_case_part_srfr"
            >
                <v-dialog
                    v-model="dialog_app_part_srfr"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dense dark color="primary">
                            <v-btn
                                icon
                                dark
                                @click="close_dialog_app_part_srfr()"
                                :disabled="!valid_case_part_srfr"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>

                            <v-toolbar-title>
                                <v-row>
                                    <v-col cols="10">
                                        <b>Add Part</b>
                                    </v-col>
                                </v-row>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete
                                        outlined
                                        dense
                                        label="Part"
                                        v-model="case_part.part"
                                        :items="data_part_srfr"
                                        item-text="part_description"
                                        return-object
                                        menu-props="auto"
                                        hide-details
                                        @input="checksinglepart_casepart_srfr()"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-row>

                            <div v-if="form_1.case_part.length > 0">
                                <v-row
                                    :class="
                                        index_case_part > 0 ? 'mar-t-25' : ''
                                    "
                                    v-for="(row_case_part,
                                    index_case_part) in form_1.case_part"
                                    :key="index_case_part"
                                >
                                    <v-col cols="4">
                                        <b
                                            >{{ index_case_part + 1 }}.{{
                                                row_case_part.part_description
                                            }}</b
                                        >
                                    </v-col>
                                    <v-col cols="6" class="mar-t-25">
                                        <v-select
                                            class="mt-6"
                                            dense
                                            outlined
                                            :items="part_item"
                                            item-text="text"
                                            item-value="id"
                                            label="Status part"
                                            v-model="row_case_part.status"
                                            required
                                            :rules="statusR"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn
                                            small
                                            fab
                                            color="red accent-2"
                                            @click="
                                                del_case_part(row_case_part)
                                            "
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- btn - action -->
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"
import VueTimepicker from "vue2-timepicker/src"
import "vue2-timepicker/dist/VueTimepicker.css"
import VueUploadMultipleImage from "vue-upload-multiple-image"
import { StreamBarcodeReader, ImageBarcodeReader } from "vue-barcode-reader"
import resizebase64 from "resize-base64"

import { mapState, mapMutations } from "vuex"
import DirectionsRenderer from "../../../test/components/DirectionsRenderer.js"

import ISmart from "./ISmart.vue"
import Signature from "./Signature.vue"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        DirectionsRenderer,
        VueUploadMultipleImage,
        VueTimepicker,
        StreamBarcodeReader,
        ImageBarcodeReader,
        ISmart,
        Signature,
    },
    props: ["chkViewMain", "status_onsite_at"],
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    watch: {
        status_onsite_at: function(val) {
            if (this.num_case_x > 0) {
                this.get_data(this.onsite_at, this.active_onsite_at)
            }
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }

        if (localStorage.fullname == "Benjaporn Chayapanja") {
            //เปิดใช้งานเฉพาะพี่ก้อย Inv
            this.chkViewKbank = true
        }
    },
    mounted() {
        this.get_data()
        this.get_emp_id()
        if (this.team_name != "ONSITE" && this.team_name != "SVC") {
            this.avoid_Highways = true
        } else {
            this.avoid_Highways = false
        }
    },
    created() {
        window.addEventListener("beforeunload", function(event) {
            event.returnValue = "Write something"
        })
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),

        // บันทึก log การโทรแบบเงียบ ไม่แจ้งเตือนผู้ใช้ และไม่ขวางการโทร
        saveCallLog(subcase_id) {
            if (!subcase_id) return
            axios
                .post(url + "engineer/save-call-log", { subcase_id }, this.tk)
                .catch(() => {})
        },

        async get_data(d, num) {
            this.dialog_loading = true
            if (this.chkViewMain === "return") {
                this.mutateIsLoading()

                setTimeout(() => {
                    this.dialog_loading = false
                    this.mutateIsLoading()
                    // this.google_map_api()
                    this.get_map_start()
                    let geocoder = new google.maps.Geocoder()
                    this.get_address()
                }, 1500)

                if (d != "" && d != undefined) {
                    this.onsite_at = d
                    this.active_onsite_at = num
                } else {
                    this.onsite_at = this.status_onsite_at[0].onsite_at
                }
            } else if (
                this.chkViewMain === "Onsite" ||
                this.chkViewKbank == true
            ) {
                let send
                if (this.chkViewKbank == true) {
                    send = 1
                } else {
                    if (d != "" && d != undefined) {
                        this.onsite_at = d
                        this.active_onsite_at = num
                    } else {
                        this.onsite_at = this.status_onsite_at[0].onsite_at
                    }
                    send = this.onsite_at

                    let date = new Date(this.onsite_at)
                    date.setDate(date.getDate() + 1)
                    this.date_min = date.toISOString().substr(0, 10)
                }

                this.mutateIsLoading()
                await axios
                    .get(url + "engineer/view-assigned/" + send, this.tk)
                    .then((response) => {
                        // console.log(response.data, "- view-assigned")
                        this.dialog_loading = false

                        // const filteredItems = response.data.filter(
                        //     (item) => item.eeg_subcase_status_id != 9
                        // )

                        // this.mutateIsLoading()
                        // // console.log(this.num_case_x)
                        // this.num_case_x = filteredItems.length
                        // if (
                        //     filteredItems.length === 0 &&
                        //     this.show_ismart == false
                        // ) {
                        //     this.onsite_at = ""
                        //     this.$emit("select_menu")
                        // } else {
                        //     this.data_main = filteredItems
                        //     this.data_main_Kbank = filteredItems
                        // }
                        this.num_case_x = response.data.length
                        if (
                            response.data.length === 0 &&
                            this.show_ismart == false &&
                            this.show_rate != true &&
                            this.show_sign != true
                        ) {
                            this.onsite_at = ""
                            this.$emit("select_menu")
                        } else {
                            this.data_main = response.data
                            this.data_main_Kbank = response.data
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },

        cal_date_eegX(st1, st2) {
            let date = new Date()
            var h = date.getHours()
            var m = date.getMinutes()
            var s = date.getSeconds()
            let year = date.toLocaleString("default", {
                year: "numeric",
            })
            let month = date.toLocaleString("default", {
                month: "2-digit",
            })
            let day = date.toLocaleString("default", { day: "2-digit" })

            if (st1 == "main") {
                let dateD = `${year}-${month}-${day}T${h}:${m}:${s}Z`
                let myArray = dateD.split(" ")
                let arr1 =
                    myArray.length == 1
                        ? myArray[0].split("-")
                        : myArray[1].split("-")
                let formattedDate =
                    myArray.length == 1
                        ? dateD
                        : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`

                return formattedDate
            } else {
                if (st2 == 1) {
                    let date1x = `${year}-${month}-${day}T${this.form_eeg_1.start.HH}:${this.form_eeg_1.start.mm}:00Z`
                    let myArray = date1x.split(" ")
                    let arr1 =
                        myArray.length == 1
                            ? myArray[0].split("-")
                            : myArray[1].split("-")
                    let formattedDate =
                        myArray.length == 1
                            ? date1x
                            : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`
                    return formattedDate
                } else if (st2 == 2) {
                    let date2x = `${year}-${month}-${day}T${this.form_eeg_1.stop.HH}:${this.form_eeg_1.stop.mm}:00Z`
                    let myArray = date2x.split(" ")
                    let arr1 =
                        myArray.length == 1
                            ? myArray[0].split("-")
                            : myArray[1].split("-")
                    let formattedDate =
                        myArray.length == 1
                            ? date2x
                            : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`
                    return formattedDate
                } else if (st2 == 3) {
                    let date12x = `${year}-${month}-${day}T${this.form_eeg_2.start.HH}:${this.form_eeg_2.start.mm}:00Z`
                    let myArray = date12x.split(" ")
                    let arr1 =
                        myArray.length == 1
                            ? myArray[0].split("-")
                            : myArray[1].split("-")
                    let formattedDate =
                        myArray.length == 1
                            ? date12x
                            : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`
                    return formattedDate
                } else if (st2 == 4) {
                    let date22x = `${year}-${month}-${day}T${this.form_eeg_2.stop.HH}:${this.form_eeg_2.stop.mm}:00Z`
                    let myArray = date22x.split(" ")
                    let arr1 =
                        myArray.length == 1
                            ? myArray[0].split("-")
                            : myArray[1].split("-")
                    let formattedDate =
                        myArray.length == 1
                            ? date22x
                            : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`
                    return formattedDate
                } else if (st2 == 5) {
                    let date32x = `${year}-${month}-${day}T${this.form_eeg_2.ActualArrivalTime.HH}:${this.form_eeg_2.ActualArrivalTime.mm}:00Z`
                    let myArray = date32x.split(" ")
                    let arr1 =
                        myArray.length == 1
                            ? myArray[0].split("-")
                            : myArray[1].split("-")
                    let formattedDate =
                        myArray.length == 1
                            ? date32x
                            : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`
                    return formattedDate
                }
            }
        },
        async save_eeg_step(st) {
            console.log(st)
            this.dialog_loading = true
            let datax
            if (st == "Engineer Traveling") {
                let Traveling = {
                    CaseExchange: {
                        EventType: "PartnerUpdates",
                        EventSubType: "Updates",
                        Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                        IncomingChannel: "EEG",
                        WorkOrder: {
                            WorkOrderID: this.data_eeg1.wonumber,
                            PartnerName: "APJ_Acacia_P",
                            PartnerStatus: "Partner Traveling",
                            PartnerStatusDateTime: this.cal_date_eegX(
                                "main",
                                ""
                            ),
                            BookingDetails: {
                                StartTime: this.cal_date_eegX("sub", 1),
                                EndTime: this.cal_date_eegX("sub", 2),
                            },
                        },
                        Notes: {
                            NotesDescription: "$#CE Traveling#$",
                            ExternallyVisible: "Yes",
                        },
                    },
                }
                datax = {
                    status: 3,
                    subcase_id: this.data_eeg1.subcase_id,
                    maincase_id: this.data_eeg1.maincase_id,
                    project_name: this.data_eeg1.project_name,
                    eeg: {
                        Traveling: Traveling,
                    },
                }
            } else if (st == "Engineer Onsite") {
                let Partner_Onsite = {
                    CaseExchange: {
                        EventType: "PartnerUpdates",
                        EventSubType: "Updates",
                        Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                        IncomingChannel: "EEG",

                        WorkOrder: {
                            WorkOrderID: this.data_eeg1.wonumber,
                            PartnerName: "APJ_Acacia_P",
                            PartnerStatus: "Partner Onsite",
                            PartnerStatusDateTime: this.cal_date_eegX(
                                "main",
                                ""
                            ),
                            BookingDetails: {
                                StartTime: this.cal_date_eegX("sub", 3),
                                EndTime: this.cal_date_eegX("sub", 4),
                                ActualArrivalTime: this.cal_date_eegX("sub", 5),
                            },
                        },
                        Notes: {
                            NotesDescription: "$#CE On Site#$",
                            ExternallyVisible: "Yes",
                        },
                    },
                }
                datax = {
                    status: 4,
                    subcase_id: this.data_eeg1.subcase_id,
                    maincase_id: this.data_eeg1.maincase_id,
                    project_name: this.data_eeg1.project_name,
                    eeg: {
                        Partner_Onsite: Partner_Onsite,
                    },
                }
            }

            // console.log(datax, "-save-scheduled-status")
            await axios
                .post(url + "engineer/save-scheduled-status", datax, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.$swal("บันทึกรายการสำเร็จ", {
                        icon: "success",
                        button: false,
                        timer: 2000,
                    })
                    this.form_eeg_1 = {
                        start: {
                            HH: "",
                            mm: "",
                        },
                        stop: {
                            HH: "",
                            mm: "",
                        },
                    }
                    this.form_eeg_2 = {
                        start: {
                            HH: "",
                            mm: "",
                        },
                        stop: {
                            HH: "",
                            mm: "",
                        },
                        ActualArrivalTime: {
                            HH: "",
                            mm: "",
                        },
                    }
                    this.get_data()
                    this.dialog = false
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        close_dialog() {
            this.customer_email = null
            this.dialog = false
            this.chk_form_action = 0
            this.chk_pj = ""
            this.chk_cso = false
            this.chk_attach = false

            //KBANK
            this.form_1.sn = ""
            this.form_1.persend = ""
            this.form_1.page_remaining = ""
            this.form_1.page_printer = ""

            this.engineer_status = ""
            this.form_1.fid_text = ""
            this.form_1.part = {}
            this.form_1.ct_old = {}
            this.form_1.ct_new = {}
            this.form_1.singlepart = {}
            this.form_1.start = []
            this.form_1.stop = []
            this.form_1.csono = ""
            this.form_1.lat = ""
            this.form_1.lng = ""
            this.form_1.address = ""
            this.form_1.travel_time = ""
            this.form_1.km = ""
            this.form_1.cso = []
            this.form_1.uefi = []
            this.form_1.attach = []
            this.form_1.maincase_id = ""
            this.form_1.subcase = ""
            this.form_1.email = ""
            this.form_1.solution = ""
            this.form_1.printcount = ""

            this.mapEnd.lat = ""
            this.mapEnd.lng = ""

            this.form_1.customer_level = null
            this.form_1.engineer_status = ""

            //new step
            this.chk_save_step = 1
            this.chk_save_data = false
            this.chk_save_img = false
            this.chk_save_data_img = false

            this.countNumTimer = 0

            this.chk_save_img_skip = false

            //case part
            this.form_1.case_part = []
            this.case_part.part = ""
            this.case_part.barcode = false

            this.ce_symptom = ""

            this.form_1.ce_symptom = ""

            this.show_rate = false
            this.show_sign = false
            this.data_sign = ""
            this.show_ismart = false
            this.data_ismart = ""
            if (this.num_case_x == 0) {
                this.get_data(this.onsite_at, this.active_onsite_at)
            }

            this.data_eeg1 = []
            this.form_eeg_1 = {
                start: {
                    HH: "",
                    mm: "",
                },
                stop: {
                    HH: "",
                    mm: "",
                },
            }
            this.form_eeg_2 = {
                start: {
                    HH: "",
                    mm: "",
                },
                stop: {
                    HH: "",
                    mm: "",
                },
                ActualArrivalTime: {
                    HH: "",
                    mm: "",
                },
            }

            this.secondary_item = []
            this.resolution_item = []
            this.nmu.secondary = ""
            this.nmu.resolution = ""
            this.nmu.version = ""
        },
        close_dialogAdd() {
            this.form_return.onsite_at = ""
            this.form_return.lat = ""
            this.form_return.lat = ""
            this.form_return.lat_current = ""
            this.form_return.lng_current = ""
            this.form_return.address = ""
            this.form_return.km = ""
            this.form_return.travel_time = ""
            this.form_return.return_to = ""
            this.form_return.remark = ""
            this.form_return.attach = []
            this.chk_attach4 = false
            this.dialogAdd = false

            this.show_rate = false
            this.show_sign = false
            this.data_sign = ""

            this.show_ismart = false
            this.data_ismart = ""
        },
        async change_btn_action(num) {
            if (num === 1) {
                let today = new Date()
                let HHs = today.getHours()
                let mStop = today.getMinutes()
                let mStart

                if (HHs <= 9) {
                    HHs = "0" + HHs.toString()
                } else {
                    HHs = HHs.toString()
                }

                if (mStop <= 15) {
                    if (mStop <= 9) {
                        mStop = "0" + mStop.toString()
                    } else {
                        mStop = mStop.toString()
                    }
                    mStart = "00"
                } else {
                    mStart = mStop - 15
                    if (mStart <= 9) {
                        mStart = "0" + mStart.toString()
                    } else {
                        mStart = mStart.toString()
                    }
                }
                this.form_1.start = {
                    HH: HHs,
                    mm: mStart.toString(),
                }

                this.form_1.stop = {
                    HH: HHs.toString(),
                    mm: mStop.toString(),
                }

                if (
                    this.chk_pj == "CDAX" ||
                    this.chk_pj == "S-Print" ||
                    this.chk_pj == "SRFR"
                ) {
                    // console.log("-Api search symtom")
                    this.search_symptom()
                }

                if (
                    this.chk_pj == "CDAX" ||
                    this.chk_pj == "S-Print" ||
                    this.chk_pj == "SRFR"
                ) {
                    // console.log("-Api search solution")
                    this.search_solution()
                }
                //
            } else {
                if (num === 7) {
                    await axios
                        .get(url + "engineer/get-engineer-zone", this.tk)
                        .then((response) => {
                            this.data_emp = response.data
                        })
                }
                this.form_2.remark = ""
            }
            this.chk_form_action = num
            this.form_2.status = num
        },
        change_case(
            part,
            maincase_id,
            subcase,
            project_name,
            problem_type_name,
            case_id,
            product_group,
            warranty_type,
            case_title,
            customer_email,
            team_name,
            e_cso,
            wonumber,
            row
        ) {
            this.dialog = true
            this.data_part = part
            this.form_1.maincase_id = maincase_id
            this.form_1.subcase = subcase
            this.form_1.project_name = project_name
            this.show_title_case_id = case_id
            this.product_group = product_group
            this.warranty_type = warranty_type
            this.case_title = case_title
            this.customer_email = customer_email
            this.case_team_name = team_name
            this.e_cso = e_cso
            this.eeg_subcase_status_id = row.eeg_subcase_status_id
            this.data_eeg1 = row

            this.form_2.maincase_id = maincase_id
            this.form_2.subcase = subcase
            this.form_2.subcase_id = row.subcase_id
            this.form_2.wonumber = wonumber
            this.form_2.project_name = project_name

            // console.log(row, "--change_case")
            // console.log(this.data_part.length, "- this.data_part")

            if (this.data_part.length == 0) {
                this.show_nmu = "Y"
            } else {
                this.show_nmu = "N"
            }
            if (
                this.team_name != "ONSITE" &&
                this.team_name != "NONHP" &&
                this.team_name != "PSG" &&
                this.team_name != "IPG"
            ) {
                this.showMap = false
            }

            if (project_name === "KBANK" && problem_type_name === "Toner") {
                this.form_1.solution = "CHANGE TONER"
            }

            //แต่ก่อนมีเงื่อนไขเยอะกว่านี้ เลย if elseif เอาไว้แก้ตอนสุดท้าย
            if (project_name === "SRFR" && localStorage.team_name != "ODM") {
                this.chk_pj = project_name
            } else if (project_name === "KBANK Toner") {
                this.chk_pj = "KBANK"
            } else if (localStorage.team_name == "ODM") {
                this.form_1.csono = "ODM"
                this.chk_pj = project_name
            } else if (project_name === "CDAX") {
                this.chk_pj = project_name
            } else {
                this.chk_pj = project_name
            }

            if (project_name === "CDAX" && product_group === "Computing") {
                this.chk_fid = true
            }
            part.map((each) => {
                this.$set(this.form_1.part, "P" + each.part_issue_id, "")

                this.$set(
                    this.chk_bracode,
                    "BARCODE" + each.part_issue_id,
                    false
                )

                this.$set(
                    this.chk_bracode,
                    "BARCODE_IMG" + each.part_issue_id,
                    false
                )

                this.$set(
                    this.chk_bracode,
                    "CT_OLD" + each.part_issue_id,
                    false
                )
                this.$set(
                    this.chk_bracode,
                    "CT_NEW" + each.part_issue_id,
                    false
                )

                this.$set(
                    this.chk_bracode,
                    "CT_OLD_IMG" + each.part_issue_id,
                    false
                )
                this.$set(
                    this.chk_bracode,
                    "CT_NEW_IMG" + each.part_issue_id,
                    false
                )

                this.$set(
                    this.chk_bracode,
                    "FAB_CT_OLD" + each.part_issue_id,
                    false
                )
                this.$set(
                    this.chk_bracode,
                    "FAB_CT_NEW" + each.part_issue_id,
                    false
                )

                this.$set(this.form_1.ct_old, "CTO" + each.part_issue_id, "")

                if (each.ct_new === null) {
                    this.$set(
                        this.form_1.ct_new,
                        "CTN" + each.part_issue_id,
                        ""
                    )
                } else {
                    this.$set(
                        this.form_1.ct_new,
                        "CTN" + each.part_issue_id,
                        each.ct_new
                    )
                }

                if (each.singlepart === null) {
                    this.$set(
                        this.form_1.singlepart,
                        "PART" + each.part_issue_id,
                        ""
                    )
                    this.$set(
                        this.form_1.singlepart,
                        "PART_TEXT" + each.part_issue_id,
                        ""
                    )
                } else {
                    this.$set(
                        this.form_1.singlepart,
                        "PART" + each.part_issue_id,
                        each.singlepart
                    )
                    this.$set(
                        this.form_1.singlepart,
                        "PART_TEXT" + each.part_issue_id,
                        ""
                    )

                    this.$set(
                        this.chk_bracode,
                        "SG" + each.part_issue_id,
                        false
                    )
                }

                this.$set(this.form_1.overa, "overa" + each.part_issue_id, "No")
                this.$set(this.form_1.overb, "overb" + each.part_issue_id, "")
            })

            // ทำซับเวลา eeg_subcase_status_id = 2
            // if (
            // this.data_eeg1.eeg_subcase_status_id == null ||
            // this.data_eeg1.eeg_subcase_status_id == 2
            // ) {
            // let d1 = this.data_eeg1.schedule_range.split(" ")
            // this.form_eeg_1.start
            // this.form_eeg_1.stop
            // }
            // console.log(d1, "-data_eeg1")
        },
        change_return_to() {
            //ที่เรียกแบบนี้เผื่อเอาไว้ใช้อย่างอื่นเพิ่ม
            this.show_address = ""
            // this.google_map_api()
            this.get_map_start()
            this.calculateAndDisplayRoute(
                this.a_directionsService,
                this.a_directionsDisplay,
                this.mapStart,
                this.mapEnd,
                this.mapSVC,
                this.data_mode
            )
        },
        google_map_api() {
            //หาจุด A
            // this.get_map_start()
            //หาจุด B (จุด B ของ Return จะมาหา Api)
            //code จุด B ตรงนี้คือหาจุดปัจจุบัน
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    // console.log(position)
                    this.mapEnd.lat = position.coords.latitude
                    this.mapEnd.lng = position.coords.longitude
                    if (
                        this.team_name == "ONSITE" ||
                        this.team_name == "NONHP" ||
                        this.team_name == "PSG" ||
                        this.team_name == "IPG"
                    ) {
                        setTimeout(() => {
                            this.getDirection()
                            if (this.chkViewMain != "return") {
                                // **แก้ไขงานล่าสุดวันที่ 09/03/64 เนื่องจากลดปริมาณการใช้ google map api
                                // this.runMapsApi()
                            }
                            let geocoder = new google.maps.Geocoder()
                            this.get_address()
                        }, 2000)
                    }
                },
                (error) => {
                    // console.log(error.message, "-- message ")
                    this.$swal({
                        title: this.show_title_case_id,
                        text:
                            "เว็บไซต์ aitt.netlify.app ต้องการที่จะใช้ตำแหน่งที่ตั้งปัจจุบัน กรุณาตั้งค่าเปิดให้เข้าถึง Location ของคุณ",
                        icon: "warning",
                        button: true,
                    })
                }
            )
        },
        getDirection() {
            let directionsService = new google.maps.DirectionsService()
            let directionsDisplay = new google.maps.DirectionsRenderer({
                draggable: false,
                scrollwheel: false,
            })

            directionsDisplay.setMap(this.$refs.map.$mapObject)
            directionsDisplay.addListener("directions_changed", () => {
                this.computeTotalDistance(directionsDisplay.getDirections())
            })

            this.a_directionsService = directionsService
            this.a_directionsDisplay = directionsDisplay

            this.calculateAndDisplayRoute(
                directionsService,
                directionsDisplay,
                this.mapStart,
                this.mapEnd,
                this.mapSVC,
                this.data_mode
            )
        },
        computeTotalDistance(result) {
            let total = 0
            let time = 0
            let myroute = result.routes[0]
            total += myroute.legs[0].distance.text
            time += myroute.legs[0].duration.text

            // console.log("ระยะทาง : " + total, "ระยะเวลา : " + time, "---computeTotalDistance")
            this.form_1.travel_time = time
            this.form_1.km = total
        },
        calculateAndDisplayRoute(
            directionsService,
            directionsDisplay,
            mapStart,
            mapEnd,
            mapSVC,
            data_mode
        ) {
            if (this.chkViewMain === "return") {
                directionsService.route(
                    {
                        origin: mapStart,
                        destination: mapSVC,
                        travelMode: data_mode,
                        avoidHighways: this.avoid_Highways,
                    },
                    function(response, status) {
                        if (status === "OK") {
                            directionsDisplay.setOptions({
                                preserveViewport: true,
                            })
                            directionsDisplay.setDirections(response)
                        } else {
                            this.$swal(
                                "เคสก่อนหน้าไม่มีพิกัด / ไม่สามารถจับพิกัดปัจจุบันได้ สามารถกด Save ก่อนและเข้าไปแก้พิกัดย้อนหลังได้ที่หน้า Mileage อีกครั้ง",
                                {
                                    icon: "warning",
                                    button: false,
                                    timer: 2000,
                                }
                            )
                        }
                    }
                )
            } else {
                if (this.form_return.return_to === "SVC/WFH") {
                    directionsService.route(
                        {
                            origin: mapStart,
                            destination: mapSVC,
                            travelMode: data_mode,
                            avoidHighways: this.avoid_Highways,
                        },
                        function(response, status) {
                            if (status === "OK") {
                                directionsDisplay.setOptions({
                                    preserveViewport: true,
                                })
                                directionsDisplay.setDirections(response)
                            } else {
                                this.$swal(
                                    "เคสก่อนหน้าไม่มีพิกัด / ไม่สามารถจับพิกัดปัจจุบันได้ สามารถกด Save ก่อนและเข้าไปแก้พิกัดย้อนหลังได้ที่หน้า Mileage อีกครั้ง",
                                    {
                                        icon: "warning",
                                        button: false,
                                        timer: 2000,
                                    }
                                )
                            }
                        }
                    )
                } else {
                    directionsService.route(
                        {
                            origin: mapStart,
                            destination: mapEnd,
                            travelMode: data_mode, // ห้ามลบเทสยุ
                            // travelMode: "DRIVING",
                            avoidHighways: this.avoid_Highways,
                        },
                        function(response, status) {
                            // console.log(status, mapStart, mapEnd, "---calculateAndDisplayRoute onsite")
                            if (status === "OK") {
                                directionsDisplay.setOptions({
                                    preserveViewport: true,
                                })
                                directionsDisplay.setDirections(response)
                            } else {
                                this.$swal(
                                    "เคสก่อนหน้าไม่มีพิกัด / ไม่สามารถจับพิกัดปัจจุบันได้ สามารถกด Save ก่อนและเข้าไปแก้พิกัดย้อนหลังได้ที่หน้า Mileage อีกครั้ง",
                                    {
                                        icon: "warning",
                                        button: false,
                                        timer: 2000,
                                    }
                                )
                            }
                        }
                    )
                }
            }

            if (
                this.team_name != "ONSITE" &&
                this.team_name != "NONHP" &&
                this.team_name != "PSG" &&
                this.team_name != "IPG"
            ) {
                this.showMap = false
            }
        },
        runMapsApi() {
            let geocoder = new google.maps.Geocoder()

            let pointCenter = new google.maps.LatLng(
                this.mapEnd.lat,
                this.mapEnd.lng
            )
            let PlacesService = new google.maps.places.PlacesService(
                this.$refs.map.$mapObject
            )

            PlacesService.nearbySearch(
                {
                    location: pointCenter,
                    radius: 300,
                },
                (results, status) => {
                    if (status == google.maps.places.PlacesServiceStatus.OK) {
                        this.data_center_point = results
                    } else {
                        console.log("Error", status)
                    }
                }
            )
        },
        add_gps(idx) {
            this.mapEnd.lat = this.data_center_point[
                idx
            ].geometry.location.lat()
            this.mapEnd.lng = this.data_center_point[
                idx
            ].geometry.location.lng()
            // this.mapEnd = this.data_center_point[idx].geometry.location

            this.get_address()
            this.calculateAndDisplayRoute(
                this.a_directionsService,
                this.a_directionsDisplay,
                this.mapStart,
                // this.mapEnd,
                this.data_center_point[idx].geometry.location,
                this.mapSVC,
                this.data_mode
            )
        },
        async get_map_start() {
            await axios
                .get(url + "engineer/last-location/" + this.onsite_at, this.tk)
                .then((response) => {
                    this.mapStart.lat = parseFloat(response.data.last.lat)
                    this.mapStart.lng = parseFloat(response.data.last.lng)

                    this.mapSVC.lat = parseFloat(response.data.svc.lat)
                    this.mapSVC.lng = parseFloat(response.data.svc.lng)
                    this.google_map_api()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        get_address() {
            let geocoder = new google.maps.Geocoder()
            geocoder.geocode({ latLng: this.mapEnd }, (results, status) => {
                // อย่าพึ่งลบ เอาไว้หาตำแหน่ง บ้านเลขที่ ตำบล อำเภอ จังหวัด รหัสไปรษณี
                // results[0].address_components.map((r, i) => {
                // console.log(r.long_name, " = ", r.types[r.types.length - 1])
                // console.log(
                //     r.long_name,
                //     " = ",
                //     r.types,
                //     " > ",
                //     r.types[r.types.length - 1]
                // )
                // })
                if (status === "OK") {
                    this.show_address = results[0].formatted_address
                } else {
                    this.show_addres = ""
                }
            })
        },
        uploadImageSuccess(formData, index, fileList) {
            // console.log("data", formData, index, fileList)

            this.form_1.cso = fileList
        },
        beforeRemove(index, done, fileList) {
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        uploadImageSuccess2(formData, index, fileList) {
            // console.log("data", formData, index, fileList)

            this.form_1.uefi = fileList
        },
        beforeRemove2(index, done, fileList) {
            // console.log("index", index, fileList)
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage2(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        uploadImageSuccess3(formData, index, fileList) {
            // console.log("data", formData, index, fileList)

            this.form_1.attach = fileList
        },
        beforeRemove3(index, done, fileList) {
            // console.log("index", index, fileList)
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage3(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        uploadImageSuccess4(formData, index, fileList) {
            // console.log("data", formData, index, fileList)
            this.form_return.attach = fileList
        },
        beforeRemove4(index, done, fileList) {
            // console.log("index", index, fileList)
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage4(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        dataChange() {},
        dataChange2() {},
        dataChange3() {},
        dataChange4() {},
        Skip_Upload() {
            this.chk_save_img_skip = true
            this.chk_save_img = true
        },
        async save_close_case_img() {
            let chk_save = false

            if (this.form_1.cso.length == 0 && this.e_cso == "N") {
                this.chk_cso = true
            } else if (
                this.form_1.attach.length === 0 &&
                this.product_group === "Printing"
            ) {
                this.chk_cso = false
                this.chk_attach = true
            } else {
                this.chk_cso = false
                this.chk_attach = false
            }

            if (!this.chk_cso && !this.chk_attach) {
                this.chk_save_data_img = true
                chk_save = true
            }

            if (chk_save === true) {
                this.countNumTimer = 0
                this.countTimer()
                this.chk_save_step = 2
                // this.google_map_api()
                this.get_map_start()

                let formData = new FormData()
                formData.append("maincase_id", this.form_1.maincase_id)
                formData.append("subcase", this.form_1.subcase)
                if (undefined !== this.form_1.cso && this.form_1.cso.length) {
                    for (let i = 0; i < this.form_1.cso.length; i++) {
                        let img_cso = resizebase64(
                            this.form_1.cso[i].path,
                            1000,
                            1000
                        )
                        formData.append(`cso[${i}]`, img_cso)
                    }
                }

                if (undefined !== this.form_1.uefi && this.form_1.uefi.length) {
                    for (let i = 0; i < this.form_1.uefi.length; i++) {
                        let img_uefi = resizebase64(
                            this.form_1.uefi[i].path,
                            750,
                            750
                        )
                        formData.append(`uefi[${i}]`, img_uefi)
                    }
                }

                if (
                    undefined !== this.form_1.attach &&
                    this.form_1.attach.length
                ) {
                    let size_attach = 0
                    this.chk_pj == "MPS"
                        ? (size_attach = 1000)
                        : (size_attach = 750)
                    for (let i = 0; i < this.form_1.attach.length; i++) {
                        let img_attach = resizebase64(
                            this.form_1.attach[i].path,
                            size_attach,
                            size_attach
                        )
                        formData.append(`attach[${i}]`, img_attach)
                    }
                }
                //Save Img
                await axios
                    .post(url + "engineer/upload", formData, this.tk)
                    .then((response) => {
                        this.chk_save_data_img = false
                        this.chk_save_img = true
                    })
                    .catch(function(error) {
                        console.log(error, "-- upload img error")
                        this.$swal({
                            title: this.show_title_case_id,
                            text:
                                "ปิดงานไม่สำเร็จ รบกวนติดต่อ Programmer Team !",
                            icon: "warning",
                            button: true,
                        })
                    })
            }
        },
        async save_close_case() {
            let chk_save

            if (
                this.form_1.customer_level == null &&
                this.form_1.engineer_status === "Complete"
            ) {
                chk_save = false
                this.chk_customer_level = true
            } else {
                this.chk_customer_level = false
            }

            if (!this.chk_customer_level) {
                chk_save = true
            }

            if (chk_save === true) {
                this.chk_save_data = true
                // this.form_1.solution = this.form_1.solution.toUpperCase()
                let time_1
                let time_2
                let chk_skip
                this.chk_save_img_skip == false
                    ? (chk_skip = "N")
                    : (chk_skip = "Y")

                time_1 = this.form_1.start["HH"] + ":" + this.form_1.start["mm"]
                time_2 = this.form_1.stop["HH"] + ":" + this.form_1.stop["mm"]

                let datax
                let datax2

                //     if (
                //     this.data_eeg1.project_name == "CDAX" &&
                //     this.data_eeg1.show_ismart == "Y"
                // ) {

                if (
                    (this.form_1.engineer_status === "Complete" ||
                        this.form_1.engineer_status === "Pickup return" ||
                        this.form_1.engineer_status === "Waiting") &&
                    this.data_eeg1.show_ismart == "Y" &&
                    this.data_eeg1.project_name == "CDAX" &&
                    this.data_eeg1.skip_ismart == "N"
                ) {
                    let Partner_Complete = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",

                            WorkOrder: {
                                WorkOrderID: this.data_eeg1.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Partner Complete",
                                PartnerStatusDateTime: this.cal_date_eegX(
                                    "main",
                                    ""
                                ),
                            },
                            Resolution: {
                                Repair: {
                                    SystemFixedTime: this.data_main
                                        .booking_end_time,
                                },
                            },
                            Notes: {
                                NotesDescription: "$#Completed - SLC Action#$",
                                ExternallyVisible: "Yes",
                            },
                        },
                    }

                    datax = {
                        Partner_Complete: Partner_Complete,
                    }

                    this.form_1.eeg = datax

                    if (this.local_status != "") {
                        let Note_Update_All = {
                            CaseExchange: {
                                EventType: "PartnerUpdates",
                                EventSubType: "Updates",
                                Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                                IncomingChannel: "EEG",
                                WorkOrder: {
                                    WorkOrderID: this.data_eeg1.wonumber,
                                    PartnerName: "APJ_Acacia_P",
                                    PartnerStatusDateTime: this.cal_date_eegX(
                                        "main",
                                        ""
                                    ),
                                },
                                Notes: {
                                    NotesDescription: `$#${this.local_status}#$`,
                                    ExternallyVisible: "Yes",
                                },
                                Attachment: {
                                    FileType: null,
                                    FileName: null,
                                    FileContent: null,
                                },
                            },
                        }
                        datax2 = {
                            Note_Update_All: Note_Update_All,
                        }
                        this.form_1.eeg2 = datax2
                    }
                } else {
                    if (
                        this.local_status != "" &&
                        this.data_eeg1.show_ismart == "Y" &&
                        this.data_eeg1.project_name == "CDAX" &&
                        this.data_eeg1.skip_ismart == "N"
                    ) {
                        let Note_Update_All = {
                            CaseExchange: {
                                EventType: "PartnerUpdates",
                                EventSubType: "Updates",
                                Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                                IncomingChannel: "EEG",
                                WorkOrder: {
                                    WorkOrderID: this.data_eeg1.wonumber,
                                    PartnerName: "APJ_Acacia_P",
                                    PartnerStatusDateTime: this.cal_date_eegX(
                                        "main",
                                        ""
                                    ),
                                },
                                Notes: {
                                    NotesDescription: `$#${this.local_status}#$`,
                                    ExternallyVisible: "Yes",
                                },
                                Attachment: {
                                    FileType: null,
                                    FileName: null,
                                    FileContent: null,
                                },
                            },
                        }
                        datax2 = {
                            Note_Update_All: Note_Update_All,
                        }
                        this.form_1.eeg2 = datax2
                    }
                }

                // console.log(this.form_1, "---save close case")
                // console.log(this.data_part, "---data_part")
                // console.log({
                //     km: this.form_1.km,
                //     travel_time: this.form_1.travel_time,
                //     lat: this.mapEnd.lat,
                //     lng: this.mapEnd.lng,
                //     lat_start: this.mapStart.lat,
                //     lng_start: this.mapStart.lng,
                // }, "---mileage check")

                let formData = new FormData()
                formData.append("part", JSON.stringify(this.form_1.part))
                formData.append("skip_upload", chk_skip)
                formData.append("start", time_1)
                formData.append("stop", time_2)
                formData.append("lat", this.mapEnd.lat)
                formData.append("lng", this.mapEnd.lng)
                formData.append("csono", this.form_1.csono)
                formData.append("address", this.show_address)
                formData.append("travel_time", this.form_1.travel_time)
                formData.append("km", this.form_1.km)
                formData.append("maincase_id", this.form_1.maincase_id)
                formData.append("subcase", this.form_1.subcase)
                formData.append("email", this.form_1.email)
                formData.append("solution", this.form_1.solution)
                formData.append("customer_level", this.form_1.customer_level)
                formData.append("engineer_status", this.form_1.engineer_status)
                formData.append("quotation", this.form_1.quotation)
                formData.append("fid", this.form_1.fid)
                formData.append("fid_text", this.form_1.fid_text)
                formData.append("printcount", this.form_1.printcount)
                formData.append("sn_old", this.form_1.sn_old)
                formData.append("sn_new", this.form_1.sn_new)
                formData.append("sameitem_no", this.form_1.sameitem_no)
                formData.append("ce_symptom", this.form_1.ce_symptom)
                formData.append("project_name", this.form_1.project_name)

                if (
                    (this.form_1.engineer_status === "Complete" ||
                        this.form_1.engineer_status === "Pickup return" ||
                        this.form_1.engineer_status === "Waiting") &&
                    this.data_eeg1.show_ismart == "Y" &&
                    this.data_eeg1.project_name == "CDAX" &&
                    this.data_eeg1.skip_ismart == "N"
                ) {
                    formData.append("eeg", JSON.stringify(this.form_1.eeg))
                    if (this.local_status != "") {
                        formData.append(
                            "eeg2",
                            JSON.stringify(this.form_1.eeg2)
                        )
                    }

                    // formData.append("overa", JSON.stringify(this.form_1.overa))
                    // formData.append("overb", JSON.stringify(this.form_1.overb))
                } else {
                    if (
                        this.local_status != "" &&
                        this.data_eeg1.show_ismart == "Y" &&
                        this.data_eeg1.project_name == "CDAX" &&
                        this.data_eeg1.skip_ismart == "N"
                    ) {
                        formData.append(
                            "eeg2",
                            JSON.stringify(this.form_1.eeg2)
                        )
                    }
                }

                if (this.checkbox == "Y") {
                    formData.append(
                        "case_part",
                        JSON.stringify(this.form_1.case_part)
                    )
                }

                formData.append(
                    "singlepart",
                    JSON.stringify(this.form_1.singlepart)
                )
                //edit line 4317-4318 20/10/23
                formData.append("overa", JSON.stringify(this.form_1.overa))
                formData.append("overb", JSON.stringify(this.form_1.overb))

                formData.append("ct_old", JSON.stringify(this.form_1.ct_old))
                formData.append("ct_new", JSON.stringify(this.form_1.ct_new))

                if (this.chk_pj === "KBANK") {
                    formData.append("sn", this.form_1.sn)
                    formData.append("persend", this.form_1.persend)
                    formData.append(
                        "page_remaining",
                        this.form_1.page_remaining
                    )
                    formData.append("page_printer", this.form_1.page_printer)
                }

                formData.append("lat_start", this.mapStart.lat)
                formData.append("lng_start", this.mapStart.lng)
                if (this.show_nmu == "Y") {
                    formData.append("nmu_primary", this.nmu.primary)
                    formData.append("nmu_secondary", this.nmu.secondary)
                    formData.append("nmu_resolution", this.nmu.resolution)
                    formData.append("nmu_version", this.nmu.version)
                }

                if (this.chk_local_status == "Y") {
                    let localStatusX = `$#${this.local_status} / ${this.form_1.solution}#$`

                    formData.append("local_status", localStatusX)
                }

                await axios
                    .post(url + "engineer/closecase", formData, this.tk)
                    .then((response) => {
                        this.e_email = response.data.email
                        this.mutatesnackbar()

                        if (chk_skip == "Y") {
                            this.$swal({
                                title: "เคสนี้มีการข้ามอัพโหลดรูป",
                                text:
                                    "กรุณาเข้าไปอัพโหลดรูปใน Menu Pending หัวข้อ UPLOAD IMG FAILED อีกครั้ง",
                                icon: "warning",
                                button: true,
                            })
                        }

                        if (this.chkViewKbank == true) {
                            this.get_data()
                        } else {
                            this.chk_save_data = false
                            this.status_onsite_at[
                                this.active_onsite_at
                            ].num_cases -= 1
                            this.form_step = {
                                num: response.data.num_pending,
                                date: this.onsite_at,
                                active: this.active_onsite_at,
                            }

                            //--signature Edit 19-01-23
                            // if (
                            //     response.data.num_pending > 0 ||
                            //     (response.data.num_pending == 0 &&
                            //         response.data.show_rate == "N" &&
                            //         response.data.show_sign == "N" &&
                            //         response.data.show_ismart == "N")
                            // ) {
                            //     this.get_data(
                            //         this.onsite_at,
                            //         this.active_onsite_at
                            //     )
                            // }
                            this.get_data(this.onsite_at, this.active_onsite_at)
                        }

                        // console.log(response.data, "-save_close_case")
                        if (
                            response.data.show_rate == "Y" ||
                            response.data.show_sign == "Y"
                        ) {
                            // this.show_rate ==  true
                            // this.show_sign ==  true
                            // this.show_ismart == true

                            this.show_rate =
                                response.data.show_rate == "Y" ? true : false
                            this.show_sign =
                                response.data.show_sign == "Y" ? true : false
                            this.data_sign = response.data.subcase_id
                        } else if (response.data.show_ismart == "Y") {
                            this.show_ismart = true
                            this.data_ismart = response.data.subcase_id
                        } else {
                            this.show_ismart = false
                            this.close_dialog()
                        }

                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                    })
                    .catch(function(error) {
                        console.log(error, "-- error close case")
                        this.$swal({
                            title: this.show_title_case_id,
                            text:
                                "ปิดงานไม่สำเร็จ รบกวนติดต่อ Programmer Team !",
                            icon: "warning",
                            button: true,
                        })
                        this.chk_save_data = false
                    })
            }
        },
        async get_emp_id() {
            await axios.get(url + "members", this.tk).then((response) => {
                this.hp_learnerid = response.data.hp_learnerid
            })
        },
        func_eeg_api() {
            let datax
            if (
                this.data_eeg1.project_name == "CDAX" &&
                this.data_eeg1.show_ismart == "Y" &&
                this.data_eeg1.skip_ismart == "N"
            ) {
                if (this.form_2.status == 2 || this.form_2.status == 3) {
                    //เลื่อนวันวิ่งงาน 2 //ติดต่อลูกค้าไม่ได้ 3
                    let Partner_Cust_Delay = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",

                            WorkOrder: {
                                WorkOrderID: this.form_2.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Partner Cust Delay",
                                PartnerStatusDateTime: this.cal_date_eegX(
                                    "main",
                                    ""
                                ),
                                RequestedDateTime:
                                    this.form_2.date + "T17:30:00",
                                BookingDetails: {
                                    StartTime: this.form_2.date + "T08:30:00",
                                    EndTime: this.form_2.date + "T17:30:00",
                                },
                            },
                            Notes: {
                                NotesDescription: `$#Customer Delay#$$#${this.form_2.remark}#$`,
                                ExternallyVisible: "Yes",
                            },
                        },
                    }
                    datax = {
                        Partner_Cust_Delay: Partner_Cust_Delay,
                    }
                } else if (this.form_2.status == 4) {
                    //ลูกค้าขอยกเลิก 4
                    let Cancelx = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",

                            WorkOrder: {
                                WorkOrderID: this.form_2.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Request to Cancel",
                                PartnerStatusDateTime: this.cal_date_eegX(
                                    "main",
                                    ""
                                ),
                            },
                            Notes: {
                                NotesDescription: `#Request to Cancel#$$#${this.form_2.remark}#$`,
                                ExternallyVisible: "Yes",
                            },
                        },
                    }

                    datax = {
                        Request_Cancel: Cancelx,
                    }
                } else if (this.form_2.status == 9) {
                    let Partner_Rescheduled = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",

                            WorkOrder: {
                                WorkOrderID: this.form_2.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Partner Rescheduled",
                                PartnerStatusDateTime: this.cal_date_eegX(
                                    "main",
                                    ""
                                ),
                                BookingDetails: {
                                    StartTime: this.form_2.date,
                                    // + "T08:30:00Z",
                                    EndTime: this.form_2.date,
                                    // + "T17:30:00Z",
                                },
                            },
                            Notes: {
                                NotesDescription: `$#Rescheduled#$$#Reschedule Reason\\${localStorage.fullname} ${this.hp_learnerid}\\nBooking Start Time:${this.form_2.date}T08:30:00\\nBooking End Time:${this.form_2.date}T17:30:00#$`,
                                ExternallyVisible: "Yes",
                            },
                        },
                    }

                    datax = {
                        Partner_Rescheduled: Partner_Rescheduled,
                    }
                }
                this.form_2.eeg = datax
            }

            if (
                this.data_eeg1.sms_status == "Y" &&
                (this.form_2.status == 2 || this.form_2.status == 4)
            ) {
                let str
                let dd = this.form_2.date.split("-")
                let date_sms = `${dd[2]}/${dd[1]}/${dd[0]}`
                if (this.form_2.status == 2) {
                    if (this.data_eeg1.sms_language == "th") {
                        str = `นัดหมายใหม่สำหรับงานซ่อมหมายเลข ${this.data_eeg1.case_id} คือวันที่ ${date_sms} กรุณารอรับการติดต่อนัดหมายจากช่างของเราอีกครั้ง สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.data_eeg1.sms_language == "en") {
                        str = `The new appointment for Case no: ${this.data_eeg1.case_id} is scheduled for ${date_sms}. Please expect a follow-up call from our technician. For inquiries, call 020781589.`
                    }
                } else if (this.form_2.status == 4) {
                    if (this.data_eeg1.sms_language == "th") {
                        str = `งานซ่อมหมายเลข ${this.data_eeg1.case_id} ได้รับการยกเลิกแล้ว สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.data_eeg1.sms_language == "en") {
                        str = `Case no: ${this.data_eeg1.case_id} has been cancelled. For more information, please call 020781589.`
                    }
                }
                let str_th = str
                str = str
                    .split("")
                    .map((char) => addZeros(char.charCodeAt(0).toString(16)))
                    .join("")
                // console.log(str)
                function addZeros(str) {
                    return ("0000" + str).slice(-4)
                }

                this.form_2.str = str
                this.form_2.str_th = str_th
                this.form_2.customer_tel = this.data_eeg1.customer_tel[0]
                this.form_2.sms_language = this.data_eeg1.sms_language
                this.form_2.sms_status = this.data_eeg1.sms_status
            }
            // console.log(this.form_2, "-save_menu_orther form_2")
            // console.log(this.data_eeg1, "-data_eeg1.show_ismart")
            this.save_menu_orther()
        },
        async save_menu_orther() {
            this.dialog_loading = true

            await axios
                .post(url + "engineer/updatecase", this.form_2, this.tk)
                .then((response) => {
                    // console.log(response)
                    if (response.data === "update - complete") {
                        this.mutatesnackbar()
                        this.close_dialog()
                        this.get_data(this.onsite_at, this.active_onsite_at)
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                        this.dialog_loading = false
                        this.form_2.maincase_id = ""
                        this.form_2.subcase = ""
                        this.form_2.status = 0
                        this.form_2.remark = ""
                        this.form_2.date = Date()
                            .toISOString()
                            .substr(0, 10)
                    } else {
                        let texts =
                            this.form_2.status == 2 || this.form_2.status
                                ? "Cust Delay"
                                : "Request to Cancel"
                        this.$swal(texts + " wrong! Please try again.", {
                            icon: "warning",
                            button: false,
                            timer: 2000,
                        })
                    }
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        save_return(t) {
    // Guard: ห้าม save ถ้าค่าจำเป็นยังไม่มา
    if (!this.onsite_at) {
        this.$swal("ไม่พบวันที่ Onsite กรุณารอสักครู่แล้วลองใหม่ หรือรีเฟรชหน้าจอ", {
            icon: "warning",
            button: false,
            timer: 2500,
        })
        return
    }

    if (!this.mapEnd.lat || !this.mapEnd.lng) {
        this.$swal(
            "ไม่พบพิกัดปัจจุบัน กรุณาเปิดสิทธิ์ Location ของเบราว์เซอร์/มือถือ แล้วลองใหม่อีกครั้ง",
            {
                icon: "warning",
                button: false,
                timer: 3000,
            }
        )
        return
    }

    let formData = new FormData()
    formData.append("onsite_at", this.onsite_at)
    formData.append("mapSVC_lat", this.mapSVC.lat)
    formData.append("mapSVC_lng", this.mapSVC.lng)
    formData.append("mapEnd_lat", this.mapEnd.lat)
    formData.append("mapEnd_lng", this.mapEnd.lng)
    formData.append("show_address", this.show_address)
    formData.append("km", this.form_1.km)
    formData.append("travel_time", this.form_1.travel_time)

    if (t === 1) {
        formData.append("remark", this.form_return.remark)
        formData.append("return_to", this.form_return.return_to)
        if (this.form_return.attach.length == 0) {
            this.chk_attach4 = true
        } else {
            if (
                undefined !== this.form_return.attach &&
                this.form_return.attach.length
            ) {
                let size_attach = 0
                this.chk_pj == "MPS"
                    ? (size_attach = 1000)
                    : (size_attach = 750)
                for (let i = 0; i < this.form_return.attach.length; i++) {
                    let img_attach = resizebase64(
                        this.form_return.attach[i].path,
                        size_attach,
                        size_attach
                    )
                    formData.append(`attach[${i}]`, img_attach)
                }
            }
            this.chk_attach4 = false
            this.$swal({
                title: "Are you sure ?",
                text: "Save Return Date Return Pickup",
                icon: "warning",
                buttons: {
                    cancel: true,
                    text: "SAVE",
                },
            }).then((conf) => {
                if (conf) {
                    axios
                        .post(url + "engineer/save-return", formData, this.tk)
                        .then((response) => {
                            this.chk_save_return = false
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                            this.get_data(this.onsite_at, this.active_onsite_at)
                            this.close_dialogAdd()
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$swal("บันทึกไม่สำเร็จ กรุณาลองใหม่", {
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        })
                }
            })
        }
    } else if (t === 2) {
        this.chk_save_return = true

        this.$swal({
            title: "Are you sure ?",
            text: "Save Return Date " + this.status_onsite_at[0].onsite_date,
            icon: "warning",
            buttons: {
                cancel: true,
                text: "SAVE",
            },
        }).then((conf) => {
            if (conf) {
                axios
                    .post(url + "engineer/save-return", formData, this.tk)
                    .then((response) => {
                        this.chk_save_return = false
                        this.mutatesnackbar()
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                        this.$emit("select_menu")
                    })
                    .catch((error) => {
                        console.log(error)
                        this.chk_save_return = false
                        this.$swal("บันทึกไม่สำเร็จ กรุณาลองใหม่", {
                            icon: "warning",
                            button: false,
                            timer: 2000,
                        })
                    })
            } else {
                this.chk_save_return = false
            }
        })
    }
},
        async checkfid_text() {
            if (this.form_1.fid === "Y" && this.form_1.fid_text.length === 27) {
                await axios
                    .post(
                        "https://eas-api.hpcloud.hp.com/v1/DecodeFailureIds/",
                        {
                            LanguageId: "en-US",
                            FailureIds: [
                                {
                                    FailureId: this.form_1.fid_text,
                                },
                            ],
                        }
                    )
                    .then((response) => {
                        if (response.data.DecodeFailureIds[0].Valid === false) {
                            this.$swal("FID invalid! Please try again.", {
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        } else if (
                            response.data.DecodeFailureIds[0].Valid === true
                        ) {
                            this.$swal("FID Valid.", {
                                icon: "success",
                                button: false,
                                timer: 2000,
                            })
                        }
                    })
            }
        },
        async checksinglepart(part) {
            let data_chk = {
                part_issue_id: part,
                singlepart: this.form_1.singlepart["PART" + part],
                maincase_id: this.form_1.maincase_id,
            }

            if (this.form_1.singlepart["PART" + part].length === 7) {
                await axios
                    .post(url + "engineer/check-singlepart", data_chk, this.tk)
                    .then((response) => {
                        if (response.data.status === "OK") {
                            this.form_1.singlepart["PART_TEXT" + part] = ""
                            this.$swal("Singlepart Valid", {
                                icon: "success",
                                button: false,
                                timer: 2000,
                            })
                        } else {
                            this.form_1.singlepart[
                                "PART_TEXT" + part
                            ] = this.form_1.singlepart["PART" + part]

                            this.form_1.singlepart["PART" + part] = ""
                            this.$swal(
                                "ไม่พบ Singlepart นี้ กรุณาลองใหม่ หรือ ติดต่อ Inventory",
                                {
                                    icon: "warning",
                                    button: false,
                                    timer: 2000,
                                }
                            )
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                    })
            }
        },

        cick_cus(c) {
            this.form_1.customer_level = c
        },
        back() {
            this.chk_form_action = 0
            this.form_1.customer_level = ""
            this.form_1.engineer_status = ""
        },
        async back_2() {
            this.mutateIsLoading()
            let formData = {
                maincase_id: this.form_1.maincase_id,
                subcase: this.form_1.subcase,
            }
            await axios
                .post(url + "engineer/clear-upload", formData, this.tk)
                .then((response) => {
                    this.chk_form_action = 0
                    this.form_1.customer_level = ""
                    this.form_1.engineer_status = ""

                    this.close_dialog()
                    this.mutateIsLoading()
                })
                .catch(function(error) {
                    console.log(error, "-- error back_2")
                })
        },
        async onDecode(result) {
            if (this.chk_action === false) {
                this.chk_action = true
                this.form_1.singlepart[
                    "PART" + this.chk_active_sg_bracode
                ] = result
                let data_chk = {
                    part_issue_id: this.chk_active_sg_bracode,
                    singlepart: this.form_1.singlepart[
                        "PART" + this.chk_active_sg_bracode
                    ],
                    maincase_id: this.form_1.maincase_id,
                }

                await axios
                    .post(url + "engineer/check-singlepart", data_chk, this.tk)
                    .then((response) => {
                        if (response.data.status === "OK") {
                            this.chk_bracode[
                                "BARCODE" + this.chk_active_sg_bracode
                            ] = false

                            this.chk_bracode[
                                "BARCODE_IMG" + this.chk_active_sg_bracode
                            ] = false

                            this.$swal("Singlepart Valid", {
                                icon: "success",
                                button: false,
                                timer: 2000,
                            })

                            this.chk_action = false
                        } else {
                            this.form_1.singlepart[
                                "PART" + this.chk_active_sg_bracode
                            ] = ""
                            this.$swal("Singlepart wrong! Please try again.", {
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                            this.chk_action = false
                        }
                    })
                    .catch(function(error) {
                        console.log(error, "error check-singlepart")
                    })
            }
        },
        onError(result) {
            // console.log(result, "-- onError")
        },
        on_ct_old_barcode(result) {
            if (result != "" || result != undefined) {
                this.form_1.ct_old["CTO" + this.chk_active_ct_bracode] = result
                this.chk_bracode["CT_OLD" + this.chk_active_ct_bracode] = false
                this.chk_bracode[
                    "CT_OLD_IMG" + this.chk_active_ct_bracode
                ] = false
            }
        },
        on_ct_new_barcode(result) {
            if (result != "" || result != undefined) {
                this.form_1.ct_new["CTN" + this.chk_active_ct_bracode] = result
                this.chk_bracode["CT_NEW" + this.chk_active_ct_bracode] = false
                this.chk_bracode[
                    "CT_NEW_IMG" + this.chk_active_ct_bracode
                ] = false
            }
        },
        open_barcode(part_issue_id, type) {
            for (let key in this.chk_bracode) {
                if (key != "SG" + part_issue_id) {
                    this.chk_bracode[key] = false
                }
            }

            if (type === "scan") {
                this.chk_bracode["BARCODE" + part_issue_id] = !this.chk_bracode[
                    "BARCODE" + part_issue_id
                ]
                if (this.chk_bracode["BARCODE" + part_issue_id] === true) {
                    this.chk_active_sg_bracode = part_issue_id
                    this.chk_bracode["BARCODE_IMG" + part_issue_id] = false
                } else {
                    this.chk_active_sg_bracode = ""
                }
            } else {
                this.chk_bracode["BARCODE_IMG" + part_issue_id] = !this
                    .chk_bracode["BARCODE_IMG" + part_issue_id]
                if (this.chk_bracode["BARCODE_IMG" + part_issue_id] === true) {
                    this.chk_active_sg_bracode = part_issue_id
                    this.chk_bracode["BARCODE" + part_issue_id] = false
                } else {
                    this.chk_active_sg_bracode = ""
                }
            }
        },
        open_barcode_ct(statuss, part_issue_id, type) {
            for (let key in this.chk_bracode) {
                if (statuss === "old" && key != "FAB_CT_OLD" + part_issue_id) {
                    this.chk_bracode[key] = false
                } else if (
                    statuss === "new" &&
                    key != "FAB_CT_NEW" + part_issue_id
                ) {
                    this.chk_bracode[key] = false
                }
            }

            if (statuss === "old") {
                if (type === "img") {
                    this.chk_bracode["CT_OLD_IMG" + part_issue_id] = !this
                        .chk_bracode["CT_OLD_IMG" + part_issue_id]
                    if (
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] === true
                    ) {
                        this.chk_bracode["CT_OLD" + part_issue_id] = false
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_NEW" + part_issue_id] = false
                    }
                } else {
                    this.chk_bracode["CT_OLD" + part_issue_id] = !this
                        .chk_bracode["CT_OLD" + part_issue_id]
                    if (this.chk_bracode["CT_OLD" + part_issue_id] === true) {
                        this.chk_bracode["CT_NEW" + part_issue_id] = false
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] === false
                    }
                }
            } else {
                if (type === "img") {
                    this.chk_bracode["CT_NEW_IMG" + part_issue_id] = !this
                        .chk_bracode["CT_NEW_IMG" + part_issue_id]
                    if (
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] === true
                    ) {
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_OLD" + part_issue_id] = false
                        this.chk_bracode["CT_NEW" + part_issue_id] = false
                    }
                } else {
                    this.chk_bracode["CT_NEW" + part_issue_id] = !this
                        .chk_bracode["CT_NEW" + part_issue_id]
                    if (this.chk_bracode["CT_NEW" + part_issue_id] === true) {
                        this.chk_bracode["CT_OLD" + part_issue_id] = false
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] = false
                    }
                }
            }

            if (
                this.chk_bracode["CT_OLD" + part_issue_id] === true ||
                this.chk_bracode["CT_NEW" + part_issue_id] === true ||
                this.chk_bracode["CT_OLD_IMG" + part_issue_id] === true ||
                this.chk_bracode["CT_NEW_IMG" + part_issue_id] === true
            ) {
                this.chk_active_ct_bracode = part_issue_id
            } else {
                this.chk_active_ct_bracode = ""
            }
        },
        uppercase() {
            this.form_1.solution = this.form_1.solution.toUpperCase()
        },
        onLoaded(result) {
            // console.log(result)
        },
        change_engineer_status(st) {
            this.form_1.customer_level = null
        },
        countTimer() {
            if (this.chk_save_img == false) {
                setTimeout(() => {
                    this.countNumTimer += 1
                    this.countTimer()
                }, 1000)
            }
        },
        func_kbank_search_case() {
            if (this.kbank_search_case.length >= 5) {
                let datak = []
                this.data_main_Kbank.map((each, index) => {
                    if (this.kbank_search_case == each.case_id) {
                        datak[0] = each
                    }
                })
                this.data_main = datak
            } else if (this.kbank_search_case.length <= 9) {
                this.data_main = this.data_main_Kbank
            }
        },
        reset_kbank_search_case() {
            this.kbank_search_case = null
            this.data_main = this.data_main_Kbank
        },
        chk_print_count() {
            let chk_r = false
            if (this.team_name == "ODM") {
                this.data_part.map((r, i) => {
                    if (
                        r.part_name == "M0H50" ||
                        r.part_name == "M0H51" ||
                        r.part_name == "X4E75" ||
                        r.part_name == "M0H50 Color" ||
                        r.part_name == "M0H51 Black" ||
                        r.part_name == "X4E75 Black"
                    ) {
                        if (this.form_1.part["P" + r.part_issue_id] == "Bad") {
                            chk_r = true
                        }
                    }
                })
            } else if (this.team_name != "ODM") {
                chk_r = true
            }

            if (chk_r == true) {
                return this.printcountR
            } else {
                return ""
            }
        },
        handleNetworkIdentified(type) {
            // console.log("connection type: ", type)
            this.NetworkSpeed.connection = type
        },
        handleNetworkSpeed(speed) {
            // console.log("downlink: ", speed)
            this.NetworkSpeed.speed = speed
        },
        doCopyLog: function(textId) {
            this.text_copy = textId
            navigator.clipboard.writeText(this.text_copy)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
        open_add_part() {
            this.dialog_app_part = true
        },
        close_dialog_app_part() {
            this.dialog_app_part = false
        },
        async open_add_part_srfr() {
            await axios
                .get(url + "engineer/get-srfr-part/" + this.form_1.maincase_id)
                .then((response) => {
                    this.data_part_srfr = response.data
                    this.dialog_app_part_srfr = true
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        close_dialog_app_part_srfr() {
            this.dialog_app_part_srfr = false
        },
        checksinglepart_casepart_srfr() {
            let chk = false
            if (this.form_1.case_part.length >= 1) {
                const found = this.form_1.case_part.find(
                    (elem) => elem.part_id === this.case_part.part.part_id
                )

                if (found == undefined) {
                    chk = true
                    this.$swal("Part Valid," + this.case_part.part, {
                        icon: "success",
                        button: false,
                        timer: 2000,
                    })
                } else {
                    chk = false
                    this.$swal("Part ซ้ำ", {
                        icon: "warning",
                        button: false,
                        timer: 2000,
                    })
                }
            } else {
                chk = true
                this.$swal("Part Valid," + this.case_part.part, {
                    icon: "success",
                    button: false,
                    timer: 2000,
                })
            }
            if (chk == true) {
                this.form_1.case_part.push(this.case_part.part)
                this.case_part.part = ""
            }
        },
        async checksinglepart_casepart() {
            if (this.case_part.part.length === 7) {
                let data_chk = {
                    singlepart: this.case_part.part,
                }

                let chk = false
                await axios
                    .post(
                        url + "engineer/check-singlepart-more",
                        data_chk,
                        this.tk
                    )
                    .then((response) => {
                        if (response.data.status === "OK") {
                            if (this.form_1.case_part.length >= 1) {
                                this.form_1.case_part.map((each, index) => {
                                    if (
                                        each.singlepart !=
                                        response.data.part.singlepart
                                    ) {
                                        chk = true
                                        this.$swal(
                                            "Singlepart Valid," +
                                                response.data.detail,
                                            {
                                                icon: "success",
                                                button: false,
                                                timer: 2000,
                                            }
                                        )
                                    } else {
                                        chk = false
                                        this.$swal("Singlepart ซ้ำ", {
                                            icon: "warning",
                                            button: false,
                                            timer: 2000,
                                        })
                                    }
                                })
                            } else {
                                chk = true

                                this.$swal(
                                    "Singlepart Valid," + response.data.detail,
                                    {
                                        icon: "success",
                                        button: false,
                                        timer: 2000,
                                    }
                                )
                            }

                            this.case_part.part = ""
                        } else {
                            chk = false
                            this.case_part.part = ""
                            this.$swal(response.data.detail, {
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        }
                        if (chk == true) {
                            this.form_1.case_part.push(response.data.part)
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                    })
            }
        },
        async gen_barcode_add_part(result) {
            this.case_part.part = result
            this.checksinglepart_casepart()
        },
        del_case_part(n) {
            const filteredItems = this.form_1.case_part.filter(
                (item) => item !== n
            )
            this.form_1.case_part = filteredItems
        },
        clear_part(st) {
            // console.log(st)
            // console.log("-- test")
            // if (this.checkbox == "N") {
            this.form_1.case_part = []
            // }
        },
        async search_symptom() {
            let send = {
                maincase_id: this.form_1.maincase_id,
            }
            await axios
                .post(url + "engineer/search-symptom", send, this.tk)
                .then((response) => {
                    this.data_symptom = response.data
                    // console.log(response, "search-symptom")
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        async search_solution() {
            let send = {
                maincase_id: this.form_1.maincase_id,
            }
            await axios
                .post(url + "engineer/search-solution", send, this.tk)
                .then((response) => {
                    this.data_solution = response.data
                    // console.log(response, "search-solution")
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        page_ismart(result) {
            console.log(result)
            console.log(this.form_step, "-form_step")
            if (this.form_step.num == 0) {
                this.get_data(this.onsite_at, this.active_onsite_at)
            }
            this.data_ismart = this.data_sign
            if (result == "Y") {
                this.show_ismart = true
                this.show_rate = false
                this.show_sign = false
            } else {
                this.show_rate = false
                this.show_sign = false
                this.show_ismart = false
                this.close_dialog()
            }
            //
        },
        func_failure_code_statte(datax, r) {
            let arrP = Object.values(datax)
            let countP = 0
            arrP.map((r, i) => {
                if (r == "Good") {
                    countP++
                }
            })

            if (countP == arrP.length && this.data_eeg1.show_ismart == "Y") {
                this.show_nmu = "Y"
            } else {
                this.show_nmu = "N"
            }
        },
        func_primary(st) {
            // console.log(this.nmu, "-this.nmu")
            if (st == 1) {
                this.secondary_item = []
                this.resolution_item = []
                this.nmu.secondary = ""
                this.nmu.resolution = ""
                this.nmu.version = ""
            }

            if (this.nmu.primary == "CMOS Reset") {
                this.secondary_item = ["Win+V", "CMOS battery"]

                if (this.nmu.secondary == "Win+V") {
                    this.nmu.resolution = "CMOS Reset -Win+V"
                    this.resolution_item = ["CMOS Reset -Win+V"]
                } else if (this.nmu.secondary == "CMOS battery") {
                    this.nmu.resolution = "CMOS Reset -CMOS battery"
                    this.resolution_item = ["CMOS Reset -CMOS battery"]
                }
            } else if (this.nmu.primary == "BIOS recovery (Win+B)") {
                this.secondary_item = ["---"]
                this.resolution_item = ["BIOS recovery (Win+B)"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "BIOS recovery (Win+B)"
            } else if (
                this.nmu.primary == "Thermal Paste Heat sink clean and Refix"
            ) {
                this.secondary_item = ["---"]
                this.resolution_item = [
                    "Thermal Paste Heat sink clean and Refix",
                ]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Thermal Paste Heat sink clean and Refix"
            } else if (this.nmu.primary == "Reseating of cables /Connectors") {
                this.secondary_item = [
                    "DC-IN CABLE",
                    "HDD CABLE",
                    "LCD DISPLAY CABLE",
                    "Webcam Cable",
                    "WLAN cable",
                    "WWAN Cable",
                    "CMOS battery Cable",
                    "Touchpad cable",
                    "Power Board cable",
                    "Antenna cable",
                    "Keyboard cable",
                    "USB Board Cable",
                    "Audio Board cable",
                    "Battery cable",
                    "Smart card reader Board cable",
                    "Fan cable",
                ]

                if (this.nmu.secondary == "DC-IN CABLE") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - DC-IN CABLE"
                } else if (this.nmu.secondary == "HDD CABLE") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  -  HDD CABLE"
                } else if (this.nmu.secondary == "LCD DISPLAY CABLE") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - LCD DISPLAY CABLE"
                } else if (this.nmu.secondary == "Webcam Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Webcam Cable"
                } else if (this.nmu.secondary == "WLAN cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - WLAN cable"
                } else if (this.nmu.secondary == "WWAN Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - WWAN Cable"
                } else if (this.nmu.secondary == "CMOS battery Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - CMOS battery Cable"
                } else if (this.nmu.secondary == "Touchpad cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Touchpad cable"
                } else if (this.nmu.secondary == "Power Board cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Power Board cable"
                } else if (this.nmu.secondary == "Antenna cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Antenna cable"
                } else if (this.nmu.secondary == "Keyboard cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Keyboard cable"
                } else if (this.nmu.secondary == "USB Board Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - USB Board Cable"
                } else if (this.nmu.secondary == "Audio Board cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Audio Board cable"
                } else if (this.nmu.secondary == "Battery cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Audio Battery cable"
                } else if (
                    this.nmu.secondary == "Smart card reader Board cable"
                ) {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Smart card reader Board cable"
                } else if (this.nmu.secondary == "Fan cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Fan cable"
                }
                this.resolution_item = [this.nmu.resolution]
            } else if (this.nmu.primary == "Memory Reseat") {
                this.secondary_item = ["---"]
                this.resolution_item = ["Memory Reseat"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Memory Reseat"
            } else if (this.nmu.primary == "cleaning of memory Slot") {
                this.secondary_item = ["---"]
                this.resolution_item = ["cleaning of memory Slot"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "cleaning of memory Slot"
            } else if (this.nmu.primary == "OS Restore") {
                this.secondary_item = ["---"]
                this.resolution_item = ["OS Restore"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "OS Restore"
            } else if (this.nmu.primary == "BOOT from custom USB drive") {
                this.secondary_item = ["---"]
                this.resolution_item = ["BOOT from custom USB drive"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "BOOT from custom USB drive"
            } else if (this.nmu.primary == "Windows settings/reinstall") {
                this.secondary_item = ["---"]
                this.resolution_item = ["Windows settings/reinstall"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Windows settings/reinstall"
            } else if (this.nmu.primary == "Power Drain") {
                this.secondary_item = ["---"]
                this.resolution_item = ["Power Drain"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Power Drain"
            } else if (this.nmu.primary == "BIOS Update") {
                this.secondary_item = ["Type Version"]
                this.resolution_item = ["BIOS Update -"]
                this.nmu.secondary = "Type Version"
                this.nmu.resolution = "BIOS Update -"
            } else if (this.nmu.primary == "Driver Update") {
                this.secondary_item = ["Type Version"]
                this.resolution_item = ["Driver Update -"]
                this.nmu.secondary = "Type Version"
                this.nmu.resolution = "Driver Update -"
            } else if (this.nmu.primary == "Firmware Update") {
                this.secondary_item = ["Type Version"]
                this.resolution_item = ["Firmware Update -"]
                this.nmu.secondary = "Type Version"
                this.nmu.resolution = "Firmware Update -"
            }
        },
        func_chk_status() {
            if (
                this.form_1.engineer_status == "Incomplete" ||
                this.form_1.engineer_status == "PUR"
            ) {
                // Local status
                this.local_status_item = [
                    "Part need to order",
                    "Additional Part",
                    "Part Backorder",
                    "Additional Part - Part Damage",
                    "Additional Part - Wrong part Ordered",
                    "Additional Part - Wrong part Shipped",
                    "Elevation - HP Pending",
                    "Rework Trade -OTC to be changed",
                    "Trade -PO/Payment awaited",
                    "Trade -Price Awaited",
                    "Trade -QI (Quote To Be Share)",
                    "Trade - Quote Approved",
                    "Trade - Quote Cancelled",
                    "Trade - Quote Generated",
                    "CRT - Open",
                ]
                this.local_status = ""
                this.chk_local_status = "Y"
            } else if (this.form_1.engineer_status == "PUR_M") {
                this.local_status_item = ["Rework - partner reassignment"]
                this.local_status = "Rework - partner reassignment"
                this.chk_local_status = "Y"
            } else if (this.form_1.engineer_status == "DOA") {
                this.local_status_item = ["DOA- HP Pending"]
                this.local_status = "DOA- HP Pending"
                this.chk_local_status = "Y"
            } else if (this.form_1.engineer_status == "Waiting") {
                this.local_status_item = ["Customer need to test unit"]
                this.local_status = "Customer need to test unit"
                this.chk_local_status = "Y"
            } else {
                this.local_status_item = []
                this.local_status = ""
                this.chk_local_status = "N"
            }

            if (
                this.form_1.engineer_status == "Complete" ||
                this.form_1.engineer_status == "Pickup return" ||
                this.form_1.engineer_status == "Waiting"
            ) {
                // this.show_nmu = "Y"
            } else {
                // this.show_nmu = "N"
            }
        },
        check_mo(mo) {
            if (mo != null && mo != "") {
                let result = mo.substring(0, 2)
                return result
            } else {
                let result = "00"
                return result
            }
        },
    },
    data() {
        return {
            dialog_loading: false,
            data_eeg1: [],
            form_eeg_1: {
                start: {
                    HH: "",
                    mm: "",
                },
                stop: {
                    HH: "",
                    mm: "",
                },
            },
            form_eeg_2: {
                start: {
                    HH: "",
                    mm: "",
                },
                stop: {
                    HH: "",
                    mm: "",
                },
                ActualArrivalTime: {
                    HH: "",
                    mm: "",
                },
            },
            eeg_subcase_status_id: null,
            hp_learnerid: null,
            form_step: {
                num: 0,
                date: "",
                active: "",
            },
            e_email: "",
            e_cso: "N",
            data_symptom: [],
            data_solution: [],
            num_case_x: "",
            show_rate: false,
            show_sign: false,
            show_ismart: false,
            data_ismart: "",
            data_sign: "",
            checkbox: "",
            checkboxR: [(v) => !!v || "โปรดระบุว่าใช้ part หรือไม่"],
            data_part_srfr: [],
            case_part: {
                part: "",
                barcode: false,
            },
            dialog_app_part: false,
            dialog_app_part_srfr: false,
            case_team_name: "",
            chk_save_return: false,
            NetworkSpeed: {
                connection: "",
                speed: "",
            },
            onsite_at: "",
            active_onsite_at: 0,
            status_color: ["indigo lighten-3", "success", "amber"],
            data_main_Kbank: [],
            chkViewKbank: false,
            kbank_search_case: null,
            countNumTimer: 0,
            chk_save_step: 1,
            chk_save_data: false,
            chk_save_img: false,
            chk_save_img_skip: false,
            chk_save_data_img: false,
            chk_pj: "",
            chk_fid: false,
            a_directionsService: "",
            chk_bracode: {},
            chk_action: false,
            chk_active_sg_bracode: "",
            chk_active_ct_bracode: "",
            // a_directionsDisplat: "",
            date_min: null,
            data_main: [],
            form_case: [],
            data_part: [],
            dialog: false,
            dialogAdd: false,
            modal: false,
            chk_form_action: 0,
            menu2: false,
            modal2: false,
            product_group: null,
            form_1: {
                maincase_id: null,
                subcase: null,
                engineer_status: null,
                customer_level: null,
                part: {},
                singlepart: {},
                ct_old: {},
                ct_new: {},
                start: {
                    HH: "",
                    mm: "",
                },
                stop: {
                    HH: "",
                    mm: "",
                },
                lat: "",
                lng: "",
                address: "",
                travel_time: "",
                km: "",
                cso: [],
                uefi: [],
                attach: [],
                fid_text: "",
                solution: "",
                case_part: [],
                ce_symptom: "",
                eeg: {},
                eeg2: {},
                overa: {},
                overb: {},
            },
            form_2: {
                date: new Date().toISOString().substr(0, 10),
                remark: "",
                maincase_id: "",
                subcase: "",
                status: 0,
            },
            form_return: {
                onsite_at: "",
                lat: "",
                lng: "",
                lat_current: "",
                lng_current: "",
                address: "",
                km: "",
                travel_time: "",
                return_to: "",
                remark: "",
                attach: [],
            },
            showMap: true,
            mapStart: {
                lat: "",
                lng: "",
            },
            mapEnd: {
                lat: "",
                lng: "",
            },
            mapSVC: {
                lat: "",
                lng: "",
            },
            customer_email: null,
            data_mode: localStorage.travel_mode,
            avoid_Highways: true,
            chk: false,
            data_center_point: [],
            show_address: "",
            text: "Success, Your work has been saved",
            valid: false,
            valid_case_part: false,
            valid_case_part_srfr: false,
            chk_cso: false,
            chk_attach: false,
            chk_attach4: false,
            chk_customer_level: false,

            // return_flagR1: [(v) => !!v || "Return Status is required"],
            return_flagR2: [(v) => !!v || "Return Override Reason is required"],
            quotationR: [(v) => !!v || "quotation Status is required"],
            fidR: [(v) => !!v || "FID Status is required"],
            fid_textR: [
                (v) => !!v || "FID Text is required",
                (v) => v.length === 27 || "FID must be less than 27 characters",
            ],
            fid_textRR: [(v) => !!v || "FID Remark  is required"],
            printcountR: [(v) => !!v || "print count  is required"],
            engineer_statusR: [(v) => !!v || "Engineer Status is required"],
            statusR: [(v) => !!v || "Status is required"],
            myIdUpload1: [(v) => !!v || "Cso is required"],
            part_issue_idR: [(v) => !!v || "Part is required"],
            startR: [(v) => !!v || "Start is required"],
            stopR: [(v) => !!v || "Stop is required"],
            csonoR: [(v) => !!v || "Csono is required"],
            solutionR: [(v) => !!v || "Solution is required"],
            ce_symptomR: [(v) => !!v || "โปรดระบุอาการเสียที่พบ (ภาษาอังกฤษ)"],
            RemarkR: [(v) => !!v || "Remark is required"],
            singlepartR: [
                (v) => !!v || "Singlepart is required",
                // (v) =>
                //     v.length === 7 ||
                //     "Singlepart must be less than 7 characters",
            ],
            // ct_oldR: [(v) => !!v || "ct old is required"],
            // ct_newR: [(v) => !!v || "ct new is required"],
            sn_oldR: [(v) => !!v || "sn old is required"],
            sn_newR: [(v) => !!v || "sn new is required"],
            sameitem_no: [(v) => !!v || "sameitem no is required"],
            nmu_1: [(v) => !!v || "NMU Primary  is required"],
            nmu_2: [(v) => !!v || "NMU Secondary  is required"],
            nmu_3: [
                (v) => !!v || "NMU Resolution Note (Auto Capture)  is required",
            ],
            nmu_4: [(v) => !!v || "Type Version Manually  is required"],
            local_statusR: [(v) => !!v || "Local Status is required"],

            team_name: localStorage.team_name,
            show_title_case_id: 0,
            tk: "",
            direction: "left",
            data_emp: [],
            zone: [],
            case_title: null,
            warranty_type: null,
            text_copy: "",
            en_item: [
                {
                    id: "Complete",
                    text: "ซ่อมเสร็จ : เครื่องลูกค้าใช้งานได้แล้ว",
                },
                {
                    id: "Incomplete",
                    text:
                        "ซ่อมไม่จบ : Verify / เสนอราคา / รอ Part / เบิก Part ใหม่",
                },
                {
                    id: "Waiting",
                    text: "ลูกค้าขอทดสอบเครื่องก่อน",
                },
                {
                    id: "PUR",
                    text: "ยกเครื่องลูกค้ามาซ่อม / NONHP วาง Spare",
                },
                {
                    id: "PUR_M",
                    text: "HP จอ Same Item",
                },
                {
                    id: "Pickup return", // ส่ง Complete
                    text: "ส่งเครื่องคืนลูกค้า",
                },
                {
                    id: "DOA",
                    text: "ทำเรื่อง DOA เครื่อง",
                },
            ],
            part_backorder_item: [
                {
                    id: "Cancel",
                    text: "ไม่ใช้ Part",
                },
                {
                    id: "Pending",
                    text: "ต้องใช้ Part / รอ Part",
                },
            ],
            part_item: [
                {
                    id: "Bad",
                    text:
                        "ใช้ Part 73 - Used & Consumed (SAUS-Used + Consumed)",
                },
                {
                    id: "Good",
                    text: "ไม่ใช้ Part 72 - Returned good (SAUN-Unused)",
                },
                {
                    id: "DOA",
                    text: "Part ทำคืน 55 - DOA - (SAUS-Used + Not Consumed)",
                },
                {
                    id: "Same Item",
                    text: "วาง Spare / Same Item",
                },
                {
                    id: "Pending",
                    text: "ยังไม่คืน Part ถือไว้ใช้ในซับต่อไป",
                },
                {
                    id: "Install",
                    text: "ติดตั้งถาวร",
                },
            ],
            show_nmu: "N",
            nmu: {
                primary: null,
                secondary: null,
                resolution: null,
                version: "",
            },
            primary_item: [
                "CMOS Reset",
                "BIOS recovery (Win+B)",
                "Thermal Paste Heat sink clean and Refix",
                "Reseating of cables /Connectors",
                "Memory Reseat",
                "cleaning of memory Slot",
                "OS Restore",
                "BOOT from custom USB drive",
                "Windows settings/reinstall",
                "Power Drain",
                "BIOS Update",
                "Driver Update",
                "Firmware Update",
            ],
            secondary_item: [],
            resolution_item: [],
            local_status_item: [],
            local_status: "",
            chk_local_status: "N",
        }
    },
}
</script>
<style scoped>
.no-pd-1 {
    margin-top: -17px;
}
.div-scoll {
    /* position: fixed; */
    overflow: auto;
    width: 100%;
    height: 228px;
    background-color: #c2eafd;
}
.drag-text {
    /* color: rgb(66, 97, 235) !important; */
    font-weight: bold !important;
    font-size: 14px !important;
}
.browse-text {
    color: rgb(66, 97, 235) !important;
    font-weight: bold !important;
    font-size: 22px !important;
}
.clear-btn {
    margin-top: -25px !important;
}
.fix-png-a {
    width: 35px;
    height: 35px;
    cursor: pointer;
    border-radius: 20px;
}
.v-speed-dial {
    position: absolute !important;
}

.v-btn--floating {
    position: relative !important;
}
.mar-t-03 {
    margin-top: -0px !important;
}
</style>
